(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4158],{

/***/ 96646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./framework/ui/desktop/header/Breadcrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	justify-content: end;\n	height: 50px;\n	align-items: center;\n\n	li {\n		position: relative;\n		padding-right: 19px;\n		margin-right: 15px;\n		font-size: var(--basic-size);\n		color: var(--gray-color);\n		line-height: 1;\n\n		&:after {\n			position: absolute;\n			top: 5px;\n			right: 0;\n			display: inline-block;\n			width: 5px;\n			height: 5px;\n			border-top: 1px solid var(--default-color);\n			border-left: 1px solid var(--default-color);\n			transform: rotate(135deg);\n			content: "";\n		}\n\n		&:last-child {\n			padding-right: 0;\n			margin-right: 0;\n\n			&:after {\n				display: none;\n			}\n		}\n\n		a:hover {\n			color: var(--emp-color);\n			text-decoration: underline;\n		}\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-7f58472-0"
})(_templateObject());
var Breadcrumbs = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: children
    });
};
/* harmony default export */ var header_Breadcrumbs = (Breadcrumbs);

// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/layout/breadcrumbs/desktop/index.tsx










var BreadcrumbLender = function(param) {
    var crumbs = param.crumbs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Breadcrumbs, {
        children: crumbs && crumbs.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                    href: item.url || "#",
                    children: item.text
                })
            }, index);
        })
    });
};
var BreadCrumbComponent = function(param) {
    var crumbArray = param.crumbArray, lastCrumb = param.lastCrumb;
    var ref, ref1;
    if (crumbArray) return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbLender, {
        crumbs: crumbArray
    });
    var queries = (0,commonUtil/* getQueryParams */.vl)();
    var dspSid = "".concat((ref = queries.dspSid) === null || ref === void 0 ? void 0 : ref.slice(0, -2), "00");
    var globalMenu = (ref1 = (0,useGlobalMenu/* default */.Z)().data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var menuLv1List = globalMenu.menuLv1List, menuLv2List = globalMenu.menuLv2List, menuLv3List = globalMenu.menuLv3List;
    var menuList = (0,_to_consumable_array/* default */.Z)(menuLv1List).concat((0,_to_consumable_array/* default */.Z)(menuLv2List), (0,_to_consumable_array/* default */.Z)(menuLv3List));
    var crumbs = (0,react.useMemo)(function() {
        var result = [];
        if (!menuList) return result;
        var lv3 = menuList.find(function(v) {
            return v.dspSid === dspSid;
        });
        if (!lv3 || lv3.lv !== 3) return result;
        var lv2 = menuList.find(function(v) {
            return v.dspSid === lv3.dspSidHi;
        });
        var lv1 = menuList.find(function(v) {
            return v.dspSid === lv2.dspSidHi;
        });
        result.push({
            text: "홈",
            url: config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL
        });
        lv1 && result.push({
            text: lv1.dspNm,
            url: lv1.dspUrl || ""
        });
        lv2 && result.push({
            text: lv2.dspNm,
            url: lv2.dspUrl || ""
        });
        result.push({
            text: lv3.dspNm,
            url: lv3.dspUrl || ""
        });
        // 마지막 Crumb가 있는 경우 추가
        if (lastCrumb) result.push(lastCrumb);
        return result;
    }, [
        globalMenu,
        dspSid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbLender, {
        crumbs: crumbs
    });
};
var Breadcrumb = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Breadcrumb Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop = (Breadcrumb);


/***/ }),

/***/ 19145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Desktop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./framework/ui/desktop/footer/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	width: 100%;\n	padding-bottom: 40px;\n	background: #fff;\n	div {\n		width: 1200px;\n		margin: auto;\n		article {\n			flex-shrink: 0;\n			box-sizing: border-box;\n		}\n	}\n	nav {\n		border-top: 1px solid #ddd;\n		border-bottom: 1px solid #ddd;\n		background-color: #f5f5f5;\n		box-sizing: border-box;\n		a {\n			line-height: 1.6;\n			font-size: 15px;\n			color: #111;\n			font-family: "PT-medium";\n		}\n		div {\n			display: flex;\n			align-items: center;\n			justify-content: space-between;\n			height: 60px;\n		}\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	nav {\n		ul {\n			display: flex;\n			gap: 30px;\n		}\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	div {\n		display: flex;\n		margin: 60px auto;\n		article:first-child {\n			width: 470px;\n			border-right: 1px solid #ddd;\n			font-size: 16px;\n			color: #555;\n			> p {\n				line-height: 1;\n				letter-spacing: -0.025em;\n				font-size: 28px;\n				font-family: "PT-medium";\n				color: #111;\n			}\n			dl {\n				display: flex;\n				gap: 20px;\n				line-height: 1;\n				margin: 30px 0;\n				dt {\n					font-family: "PT-medium";\n					color: #111;\n				}\n			}\n			ul li {\n				position: relative;\n				line-height: 1;\n				padding-left: 10px;\n				+ li {\n					margin-top: 20px;\n				}\n				&:before {\n					position: absolute;\n					top: 10px;\n					left: 0;\n					display: block;\n					width: 2px;\n					height: 2px;\n					background: #999;\n					content: "";\n				}\n				p {\n					line-height: 1.6;\n				}\n			}\n		}\n		article:nth-child(2) {\n			padding: 0 25px 0 60px;\n			ul {\n				display: flex;\n				gap: 40px;\n				li {\n					display: flex;\n					flex-direction: column;\n					align-items: center;\n					justify-content: flex-start;\n					gap: 20px;\n					width: 190px;\n					> p {\n						line-height: 1;\n						font-size: 20px;\n						letter-spacing: -0.025em;\n						em {\n							line-height: 1;\n							font-size: 26px;\n							font-family: "PT-medium";\n							color: #111;\n							letter-spacing: 0;\n						}\n					}\n					> button {\n						height: 40px;\n						line-height: 1;\n						padding: 12px 20px;\n						border: 1px solid #555;\n						background-color: #fff;\n						border-radius: 4px;\n						font-size: 14px;\n						font-family: "PT-medium";\n						color: #111;\n						white-space: nowrap;\n						box-sizing: border-box;\n						cursor: pointer;\n					}\n					&::before {\n						display: block;\n						width: 30px;\n						height: 30px;\n						margin-bottom: 5px;\n						background-repeat: no-repeat;\n						background-position: center;\n						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_pkg.png);\n						content: "";\n					}\n					&:nth-child(2):before {\n						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_air.png);\n					}\n					&:last-child:before {\n						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_region.png);\n					}\n				}\n			}\n		}\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	nav {\n		height: 60px;\n		background-color: #fff;\n		box-sizing: border-box;\n		ul:first-child {\n			display: flex;\n			gap: 30px;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	a {\n		display: block;\n		width: 34px;\n		height: 34px;\n		&:before {\n			position: absolute;\n			display: block;\n			width: 34px;\n			height: 34px;\n			border-radius: 50%;\n			background: #fff url(https://cimgcdn.ybtour.co.kr/common/footer/btn_sns.png) no-repeat;\n			content: " ";\n			background-position: ',
        ";\n		}\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	li {\n		&:nth-child(2) > a em {\n			color: #4567ad;\n			font-family: "PT-medium";\n		}\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 40px auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	article:first-child {\n		position: relative;\n		width: 780px;\n		border-right: 1px solid #ddd;\n		h5 {\n			line-height: 1;\n			margin: 0 0 30px 0;\n			font-size: 15px;\n			font-family: "PT-bold";\n			color: #222;\n		}\n		img {\n			width: 130px;\n			height: 10px;\n			margin-left: 20px;\n			vertical-align: baseline;\n		}\n		address {\n			font-size: 12px;\n			line-height: 1.8;\n			color: #777;\n			+ address {\n				margin-top: 10px;\n			}\n			+ span {\n				margin-top: 20px;\n			}\n		}\n		span {\n			display: block;\n			margin: 0;\n			font-size: 12px;\n			font-style: normal;\n			line-height: 1.8;\n			color: #777;\n		}\n		> a {\n			margin-left: 10px;\n			font-size: 12px;\n			text-decoration: underline;\n			color: #555;\n		}\n		i {\n			font-style: normal;\n			&:after {\n				display: inline-block;\n				width: 1px;\n				height: 10px;\n				margin: 0 6px 0 8px;\n				background: #999;\n				content: " ";\n			}\n		}\n	}\n	article:last-child {\n		width: 430px;\n		padding-left: 40px;\n		> a {\n			position: relative;\n			line-height: 1;\n			margin-right: 12px;\n			font-family: "PT-medium";\n			color: #111;\n			font-size: 14px;\n			&:after {\n				position: absolute;\n				top: 50%;\n				left: 100%;\n				width: 5px;\n				height: 5px;\n				margin: -3px 0 0 5px;\n				border-top: 1px solid #111;\n				border-right: 1px solid #111;\n				transform: rotate(45deg);\n				content: " ";\n			}\n		}\n		span {\n			display: flex;\n			flex-wrap: wrap;\n			justify-content: space-between;\n			gap: 10px;\n			width: 390px;\n			margin: 20px 0 25px;\n			font-size: 13px;\n		}\n		dl {\n			display: flex;\n			gap: 10px;\n			line-height: 1;\n			dt {\n				min-width: 98px;\n				color: #555;\n			}\n			dd {\n				min-width: 80px;\n				color: #111;\n				font-family: "PT-medium";\n			}\n			&:nth-child(2) {\n				dt {\n					min-width: 78px;\n				}\n			}\n		}\n		span + ul {\n			display: contents;\n			font-size: 12px;\n			color: #777;\n			li {\n				display: flex;\n				width: 100%;\n				margin: 0;\n				line-height: 1.8;\n				em {\n					width: 60px;\n				}\n				a {\n					width: 310px;\n					text-decoration: underline;\n				}\n			}\n		}\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 10px;\n	height: 60px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	height: 60px;\n	&:nth-child(1) button,\n	&:nth-child(2) button {\n		width: 165px;\n		&::before {\n			width: 165px;\n		}\n	}\n	button {\n		position: relative;\n		width: 162px;\n		height: 60px;\n		padding: 0;\n		border: 0;\n		background-color: transparent;\n		text-indent: 0;\n		cursor: pointer;\n		overflow: visible;\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n		&:before {\n			display: block;\n			height: 60px;\n			background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/btn_award_202512.png);\n			background-position: 0 0;\n			background-repeat: no-repeat;\n			content: "";\n			background-position: ',
        ";\n		}\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	ul {\n		display: flex;\n		flex-direction: column;\n		align-items: flex-start;\n		height: auto;\n		margin: 20px 0 30px;\n		li {\n			position: relative;\n			padding-left: 7px;\n			font-size: 12px;\n			color: #777;\n			&:before {\n				position: absolute;\n				top: 6px;\n				left: 0;\n				display: block;\n				width: 2px;\n				height: 2px;\n				background: #999;\n				content: " ";\n			}\n			+ li {\n				margin-top: 10px;\n			}\n			> a {\n				position: relative;\n				margin-left: 5px;\n				font-size: 12px;\n				text-decoration: underline;\n				color: #777;\n				&:after {\n					position: absolute;\n					top: 50%;\n					left: 100%;\n					width: 4px;\n					height: 4px;\n					margin: -2px 0 0 3px;\n					border-top: 1px solid #777;\n					border-right: 1px solid #777;\n					transform: rotate(45deg);\n					content: " ";\n				}\n			}\n		}\n	}\n	+ p {\n		line-height: 1.8;\n		font-size: 12px;\n		color: #777;\n	}\n'
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	right: 20px;\n	bottom: 40px;\n	z-index: 100;\n	width: 60px;\n	height: 60px;\n\n	button > span {\n		font-size: 0;\n		color: transparent;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	right: 20px;\n	bottom: 40px;\n	z-index: 100;\n	transition: bottom 0.4s;\n	",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	z-index: 105;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 4px;\n	width: 60px;\n	height: 60px;\n	border-radius: 50%;\n	background-color: #ffce3c;\n	font-size: 14px;\n	color: var(--gray-color);\n	cursor: pointer;\n\n	&:before {\n		display: block;\n		width: 20px;\n		height: 22px;\n		background-image: url(https://cimgcdn.ybtour.co.kr/common/ico/ico_chatbot.png);\n		background-repeat: no-repeat;\n		background-size: contain;\n		content: "";\n	}\n	&:after {\n		display: inline-block;\n		content: "상담";\n		font-family: "PT-bold";\n		font-size: 14px;\n		letter-spacing: -0.025em;\n		color: #111;\n	}\n	+ div {\n		position: absolute;\n		top: 0;\n		right: 30px;\n		z-index: 100;\n		display: flex;\n		justify-content: center;\n		align-items: center;\n		width: 0;\n		height: 60px;\n		padding: 0;\n		border-radius: 100px 0 0 100px;\n		background: #555;\n		overflow: hidden;\n		box-sizing: border-box;\n		opacity: 0;\n		transition: all 0.4s;\n\n		> span {\n			color: #fff;\n			font-size: 15px;\n			letter-spacing: -0.025em;\n			white-space: nowrap;\n		}\n	}\n	&:hover + div {\n		width: 245px;\n		padding: 0 45px 0 30px;\n		opacity: 1;\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	width: 60px;\n	height: 60px;\n	margin-bottom: -1px;\n	border: 1px solid var(--line-color);\n	border-radius: 50%;\n	background-color: #fff;\n	font-size: 14px;\n	color: var(--gray-color);\n	opacity: 0;\n	animation: fadeout 0.4s;\n	cursor: pointer;\n	:hover,\n	:active {\n		background-color: #111;\n		:before {\n			border-color: #fff;\n		}\n		:after {\n			background-color: #fff;\n		}\n	}\n	:before {\n		position: absolute;\n		top: 20px;\n		left: 50%;\n		display: block;\n		width: 12px;\n		height: 12px;\n		margin: 0 0 0 -6px;\n		border-top: 2px solid #111;\n		border-right: 2px solid #111;\n		transform: rotate(-45deg);\n		content: "";\n	}\n	:after {\n		position: absolute;\n		display: block;\n		top: 20px;\n		left: 50%;\n		width: 2px;\n		height: 20px;\n		background-color: #111;\n		content: "";\n	}\n\n	',
        "\n\n	@keyframes fadein {\n		0% {\n			opacity: 0;\n		}\n		100% {\n			opacity: 1;\n		}\n	}\n	@keyframes fadeout {\n		0% {\n			opacity: 1;\n		}\n		100% {\n			opacity: 0;\n		}\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 0;\n	right: 40px;\n	display: flex;\n	gap: 15px;\n	li {\n		&:nth-child(2) {\n			a {\n				&::before {\n					width: 60px;\n					background-position: -65px 0;\n				}\n			}\n		}\n		a {\n			display: block;\n			width: 100%;\n			height: 100%;\n			&::before {\n				display: block;\n				width: 65px;\n				height: 56px;\n				background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/logo_franchise.png);\n				background-size: auto 56px;\n				background-position: 0 0;\n				background-repeat: no-repeat;\n				content: "";\n			}\n		}\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}




var FooterWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-187d75ce-0"
})(_templateObject());
var Fnb = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-187d75ce-1"
})(_templateObject1());
var CsWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-187d75ce-2"
})(_templateObject2());
var LinkWrap = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-187d75ce-3"
})(_templateObject3());
var Sns = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-187d75ce-4"
})(_templateObject4());
var SnsItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-187d75ce-5"
})(_templateObject5(), function(props) {
    if (props.$sns === "facebook") {
        return "\n                0 0;\n            ";
    }
    if (props.$sns === "instagram") {
        return "\n				-34px 0;\n            ";
    }
    if (props.$sns === "youtube") {
        return "\n				-68px 0;\n            ";
    }
    if (props.$sns === "kakao") {
        return "\n				-102px 0;\n            ";
    }
    if (props.$sns === "blog") {
        return "\n				-136px 0;\n            ";
    }
    if (props.$sns === "post") {
        return "\n				-170px 0;\n            ";
    }
});
var Policies = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-187d75ce-6"
})(_templateObject6());
var CompanyInfo = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-187d75ce-7"
})(_templateObject7());
var Corporation = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-187d75ce-8"
})(_templateObject8());
var AwardList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-187d75ce-9"
})(_templateObject9());
var AwardListItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-187d75ce-10"
})(_templateObject10(), function(props) {
    if (props.$award === "ccm") {
        return "0 0";
    }
    if (props.$award === "ftc") {
        return "-175px 0";
    }
    if (props.$award === "ccm2023") {
        return "-350px 0";
    }
    if (props.$award === "knqa") {
        return "-522px 0";
    }
    if (props.$award === "scsi") {
        return "-694px 0";
    }
    if (props.$award === "icsi") {
        return "-866px 0";
    }
    if (props.$award === "isms") {
        return "-1038px 0";
    }
});
var CopyrightWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-187d75ce-11"
})(_templateObject11());
var FloatingBlock = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-187d75ce-12"
})(_templateObject12());
var TalkWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-187d75ce-13"
})(_templateObject13(), function(props) {
    return props.$show && "\n		bottom: 110px;\n	";
});
var TalkBtn = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-187d75ce-14"
})(_templateObject14());
var TopButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-187d75ce-15"
})(_templateObject15(), function(props) {
    return props.$show && "\n			opacity: 1;\n			animation: fadein 0.4s;\n	";
});
var LogoList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-187d75ce-16"
})(_templateObject16());
var Footer = function() {
    var router = useRouter();
    var ref = useState(false), topShow = ref[0], setTopShow = ref[1];
    var ref1 = useState(0), lastScrollTop = ref1[0], setLastScrollTop = ref1[1];
    var handleScroll = function() {
        var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
        if (currentScrollTop > lastScrollTop) {
            setTopShow(false);
        } else {
            setTopShow(true);
        }
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
    };
    var onClickAward = function(value) {
        window.open("https://www.ybtour.co.kr/assets/main/desktop/webcontent/awards_popup.html".concat(value ? "#award=".concat(value) : ""), "popupWindow", "width=600,height=720,left=200,top=200");
    };
    var top = useCallback(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    useEffect(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        lastScrollTop,
        router
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(FooterWrap, {
                className: "footer",
                children: [
                    /*#__PURE__*/ _jsx(Fnb, {
                        children: /*#__PURE__*/ _jsx("nav", {
                            children: /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsxs("ul", {
                                    children: [
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                                children: "고객센터"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/noticeList.yb",
                                                children: "공지사항"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/faqList.yb",
                                                children: "자주하는질문"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/qnaGuide.yb",
                                                children: "1:1문의"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/estimateWrite.yb",
                                                children: "견적문의"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/eplg/episodeList.yb",
                                                children: "여행후기"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/praiseList.yb",
                                                children: "칭찬합시다"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/freeInstallmentPopup.yb",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "무이자할부"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=",
                                                target: "_self",
                                                children: "현금영수증"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(CsWrap, {
                        children: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsxs("article", {
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "노랑풍선 고객센터"
                                        }),
                                        /*#__PURE__*/ _jsxs("dl", {
                                            children: [
                                                /*#__PURE__*/ _jsx("dt", {
                                                    children: "상담시간"
                                                }),
                                                /*#__PURE__*/ _jsx("dd", {
                                                    children: "평일 오전 9시 ~ 오후 6시 (토,일요일 및 공휴일 휴무)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            "해외항공권 변경, 투어&티켓, 렌터카 취소/변경/환불:",
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            "평일 오후 5시까지"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("p", {
                                                        children: "호텔 취소/변경/환불: 평일 오후 4시까지"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("article", {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "패키지여행 상담"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: /*#__PURE__*/ _jsx("em", {
                                                            children: "1544-2288"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        onClick: function() {
                                                            window.open("https://pkg.ybtour.co.kr/cs/arsGuide.yb");
                                                        },
                                                        children: "지역별 직통 상담번호 안내"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "자유여행 상담"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: /*#__PURE__*/ _jsx("em", {
                                                            children: "1644-3399"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "부산/지방출발 상담"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: /*#__PURE__*/ _jsx("em", {
                                                            children: "051-713-0710"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(LinkWrap, {
                        children: /*#__PURE__*/ _jsx("nav", {
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs(Policies, {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "http://company.ybtour.co.kr/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "회사소개"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/privacy.yb",
                                                    children: /*#__PURE__*/ _jsx("em", {
                                                        children: "개인정보처리방침"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/internetAgree.yb",
                                                    children: "이용약관"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/travelAgree.yb",
                                                    children: "여행약관"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/travelerInsuInfo.yb",
                                                    children: "여행자보험"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "http://company.ybtour.co.kr/agent/about",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "대리점안내"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/cs/directionGuide.yb",
                                                    children: "오시는 길"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Sns, {
                                        children: [
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "facebook",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.facebook.com/yellowballoonofficial/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 페이스북 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "instagram",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.instagram.com/yellowballoon_official/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 인스타 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "youtube",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.youtube.com/user/ybtour2013",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 유튜브 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "kakao",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pf.kakao.com/_hhAxbd",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 플러스친구 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "blog",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://blog.naver.com/yb_tour",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 네이버블로그 바로가기"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(CompanyInfo, {
                        children: /*#__PURE__*/ _jsxs(Corporation, {
                            children: [
                                /*#__PURE__*/ _jsxs("article", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("h5", {
                                            children: [
                                                "(주)노랑풍선",
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png",
                                                    alt: "코스닥상장법인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("address", {
                                            children: [
                                                "대표이사 김진국",
                                                /*#__PURE__*/ _jsx("i", {}),
                                                "서울특별시 중구 수표로31, 노랑풍선빌딩",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "사업자등록번호 104-81-64440 ",
                                                /*#__PURE__*/ _jsx("i", {}),
                                                "관광사업자등록증번호 제2006-000003호",
                                                /*#__PURE__*/ _jsx("i", {}),
                                                "통신판매업신고번호 제2008-서울중구-0278",
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "사업자 정보확인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("address", {
                                            children: [
                                                "[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 (부전동, 에이원프라자)",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "사업자등록번호 870-85-01900"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "영업배상책임보험가입 총 20억원 \xb7 한국관광협회중앙회 여행공제회 공제영업보증가입 15억 1천만원 \xb7 공제기획여행보증가입 7억원"
                                        }),
                                        /*#__PURE__*/ _jsxs(LogoList, {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        href: "http://tourinfo.or.kr/standard/partners.asp",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: "국외여행상품 정보제공 표준안 참여 여행사"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        href: "https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd= ",
                                                        target: "_self",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: "현금영수증 의무발행 가맹점"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("article", {
                                    children: [
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                            children: "고객센터"
                                        }),
                                        /*#__PURE__*/ _jsxs("span", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("dl", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("dt", {
                                                            children: "패키지여행 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("dd", {
                                                            children: "1544-2288"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("dl", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("dt", {
                                                            children: "자유여행 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("dd", {
                                                            children: "1644-3399"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("dl", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("dt", {
                                                            children: "부산/지방출발 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("dd", {
                                                            children: "051-713-0710"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "대표메일"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:master@ybtour.com",
                                                            children: "master@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "판매제휴"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:salespartner@ybtour.com",
                                                            children: "salespartner@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "마케팅제휴"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:marketing@ybtour.com",
                                                            children: "marketing@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "대리점문의"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:sales.agent@ybtour.co.kr",
                                                            children: "sales.agent@ybtour.co.kr"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("section", {
                        children: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsxs(AwardList, {
                                    children: [
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "ccm",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award1");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "소비자중심경영 명예의 전당 표창장"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "ftc",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award2");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "소비자중심경영 국무총리 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "ccm2023",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award3");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "소비자중심경영 공정거래위원장 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "knqa",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award4");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "제45회 국가품질경영대회서비스품질우수상"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "scsi",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "SCSI 대한민국 소셜미디어대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "icsi",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "ICSI 대한민국 인터넷소통대상 기업부문 대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "isms",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award6");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "정보보호 관리체계 인증"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(CopyrightWrap, {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서 해당 상품의 상품\xb7거래정보 및 거래 등에 대하여 책임을 지지 않습니다."
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다."
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
                                            }),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    "고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.",
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://pkg.ybtour.co.kr/cs/travelSafetyGuide.yb",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "자세히보기"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: "\xa9 Yellow Balloon tour. All Rights Reserved."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FloatingBlock, {
                children: /*#__PURE__*/ _jsx(TopButton, {
                    $show: topShow,
                    onClick: top,
                    children: /*#__PURE__*/ _jsx("span", {
                        children: "최상단 이동"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var footer = ((/* unused pure expression or super */ null && (Footer)));


// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
;// CONCATENATED MODULE: ./components/layout/footer/Desktop/index.tsx








var Desktop_Footer = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), topShow = ref1[0], setTopShow = ref1[1];
    var ref2 = (0,react.useState)(0), lastScrollTop = ref2[0], setLastScrollTop = ref2[1];
    var handleScroll = function() {
        var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
        if (currentScrollTop > lastScrollTop) {
            setTopShow(false);
        } else {
            setTopShow(true);
        }
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
    };
    var onClickAward = function(value) {
        window.open("https://www.ybtour.co.kr/assets/main/desktop/webcontent/awards_popup.html".concat(value ? "#award=".concat(value) : ""), "popupWindow", "width=600,height=720,left=200,top=200");
    };
    var top = (0,react.useCallback)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        lastScrollTop,
        router
    ]);
    /** 해피톡 */ var ref3 = (0,react.useState)(null), talk = ref3[0], setTalk = ref3[1];
    var globalMenuFetch = (0,useGlobalMenu/* default */.Z)();
    var globalMenu = (ref = globalMenuFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react.useEffect)(function() {
        if (!router.query.dspSid || !router.pathname.includes("/product/localList") || !globalMenu) return;
        var target = globalMenu.menuLv3List.find(function(v) {
            return v.dspSid === router.query.dspSid && v.talkYn === "Y";
        }) || null;
        if (target) setTalk(target);
    }, [
        router.pathname,
        router.query.dspSid,
        globalMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrap, {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fnb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/main.yb"),
                                                children: "고객센터"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/noticeList.yb"),
                                                children: "공지사항"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/faqList.yb"),
                                                children: "자주하는질문"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/qnaGuide.yb"),
                                                children: "1:1문의"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/estimateWrite.yb"),
                                                children: "견적문의"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/eplg/episodeList.yb"),
                                                children: "여행후기"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/praiseList.yb"),
                                                children: "칭찬합시다"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/freeInstallmentPopup.yb"),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "무이자할부"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="),
                                                target: "_self",
                                                children: "현금영수증"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "노랑풍선 고객센터"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    children: "상담시간"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                    children: "평일 오전 9시 ~ 오후 6시 (토,일요일 및 공휴일 휴무)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "해외항공권 변경, 투어&티켓, 렌터카 취소/변경/환불:",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "평일 오후 5시까지"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "호텔 취소/변경/환불: 평일 오후 4시까지"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "패키지여행 상담"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "1544-2288"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            window.open("".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/arsGuide.yb"));
                                                        },
                                                        children: "지역별 직통 상담번호 안내"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "자유여행 상담"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "1644-3399"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "부산/지방출발 상담"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "051-713-0710"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Policies, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: config_public/* default.ENV_COMPANY_URL */.Z.ENV_COMPANY_URL,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "회사소개"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/privacy.yb"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: "개인정보처리방침"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/internetAgree.yb"),
                                                    children: "이용약관"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/travelAgree.yb"),
                                                    children: "여행약관"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/travelerInsuInfo.yb"),
                                                    children: "여행자보험"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "".concat(config_public/* default.ENV_COMPANY_URL */.Z.ENV_COMPANY_URL, "/agent/about"),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "대리점안내"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/directionGuide.yb"),
                                                    children: "오시는 길"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sns, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "facebook",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "https://www.facebook.com/yellowballoonofficial/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 페이스북 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "instagram",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "https://www.instagram.com/yellowballoon_official/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 인스타 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "youtube",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "https://www.youtube.com/user/ybtour2013",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 유튜브 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "kakao",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "https://pf.kakao.com/_hhAxbd",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 플러스친구 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "blog",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "https://blog.naver.com/yb_tour",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 네이버블로그 바로가기"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Corporation, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            children: [
                                                "(주)노랑풍선",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png",
                                                    alt: "코스닥상장법인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                            children: [
                                                "대표이사 김진국",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                                                "서울특별시 중구 수표로31, 노랑풍선빌딩",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "사업자등록번호 104-81-64440 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                                                "관광사업자등록증번호 제2006-000003호",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                                                "통신판매업신고번호 제2008-서울중구-0278",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "사업자 정보확인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                            children: [
                                                "[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 (부전동, 에이원프라자)",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "사업자등록번호 870-85-01900"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "영업배상책임보험가입 총 20억원 \xb7 한국관광협회중앙회 여행공제회 공제영업보증가입 15억 1천만원 \xb7 공제기획여행보증가입 7억원"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoList, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                        href: "http://tourinfo.or.kr/standard/partners.asp",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "국외여행상품 정보제공 표준안 참여 여행사"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                        href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="),
                                                        target: "_self",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "현금영수증 의무발행 가맹점"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/main.yb"),
                                            children: "고객센터"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "패키지여행 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            children: "1544-2288"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "자유여행 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            children: "1644-3399"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "부산/지방출발 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            children: "051-713-0710"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "대표메일"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "mailto:master@ybtour.com",
                                                            children: "master@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "판매제휴"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "mailto:salespartner@ybtour.com",
                                                            children: "salespartner@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "마케팅제휴"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "mailto:marketing@ybtour.com",
                                                            children: "marketing@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "대리점문의"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "mailto:sales.agent@ybtour.co.kr",
                                                            children: "sales.agent@ybtour.co.kr"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AwardList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "ccm",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award1");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "소비자중심경영 명예의 전당 표창장"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "ftc",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award2");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "소비자중심경영 국무총리 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "ccm2023",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award3");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "소비자중심경영 공정거래위원장 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "knqa",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award4");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "제45회 국가품질경영대회서비스품질우수상"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "scsi",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "SCSI 대한민국 소셜미디어대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "icsi",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "ICSI 대한민국 인터넷소통대상 기업부문 대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "isms",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award6");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "정보보호 관리체계 인증"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightWrap, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서 해당 상품의 상품\xb7거래정보 및 거래 등에 대하여 책임을 지지 않습니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                        href: "https://pkg.ybtour.co.kr/cs/travelSafetyGuide.yb",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "자세히보기"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "\xa9 Yellow Balloon tour. All Rights Reserved."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingBlock, {
                children: [
                    talk && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalkWrap, {
                        $show: topShow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalkBtn, {
                                onClick: function() {
                                    return (0,commonUtil/* openTalk */.Vt)(talk.talkUrl);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "해피톡 상담"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: talk.talkMsg
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopButton, {
                        $show: topShow,
                        onClick: top,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "최상단 이동"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Desktop = (Desktop_Footer);


/***/ }),

/***/ 2370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Desktop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./public/P/images/ico/ico_prod.png
var ico_prod = __webpack_require__(15196);
var ico_prod_default = /*#__PURE__*/__webpack_require__.n(ico_prod);
;// CONCATENATED MODULE: ./components/style/common/history.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	z-index: 101;\n	width: 100%;\n	height: 100%;\n\n	",
        "\n	",
        "\n\n	\n	@keyframes dimmfadein {\n		from {\n			opacity: 0;\n			height: 100%;\n		}\n\n		to {\n			opacity: 1;\n		}\n	}\n	@keyframes dimmfadeout {\n		from {\n			opacity: 1;\n		}\n\n		to {\n			opacity: 0;\n		}\n	}\n\n	@keyframes slidein {\n		from {\n			transform: translate3d(100%, 0, 0);\n		}\n\n		to {\n			transform: translate3d(0, 0, 0);\n		}\n	}\n	@keyframes slideout {\n		from {\n			transform: translate3d(0, 0, 0);\n		}\n\n		to {\n			transform: translate3d(100%, 0, 0);\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	right: 0;\n	left: 0;\n	bottom: 0;\n	z-index: 100;\n	width: 100%;\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	opacity: 0;\n	transition: opacity 0.3s;\n	will-change: opacity;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	bottom: 0;\n	right: 0;\n	z-index: 100;\n	display: flex;\n	flex-direction: column;\n	width: 400px;\n	height: 100%;\n	margin: 0;\n	background: #fff;\n	transform: translate3d(100%, 0, 0);\n	transition: transform 0.3s;\n	transition-timing-function: ease-in-out;\n	will-change: transform;\n	box-sizing: border-box;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	align-items: center;\n	flex: 0 0 70px;\n	margin: 0 20px;\n	border-bottom: 1px solid #222;\n	box-sizing: border-box;\n	> div {\n		display: flex;\n		align-items: center;\n		gap: 15px;\n		> button:first-of-type {\n			min-width: 80px;\n			+ button {\n				margin: 0;\n			}\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	flex: 1 1 auto;\n	height: calc(100% - 70px);\n	overflow-x: hidden;\n	overflow-y: auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 100%;\n	height: 100%;\n	text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: -webkit-box;\n	padding-right: 30px;\n	font-size: 22px;\n	color: var(--emp-color);\n	letter-spacing: 0;\n	font-family: "PT-medium";\n	overflow: hidden;\n	text-overflow: ellipsis;\n	white-space: normal;\n	word-wrap: break-word;\n	word-break: break-all;\n	-webkit-line-clamp: 1;\n	-webkit-box-orient: vertical;\n	line-clamp: 1;\n\n	> span {\n		margin-left: 10px;\n		font-size: 16px;\n		font-weight: normal;\n		color: var(--blue-color);\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	flex: 0 0 80px;\n	width: 100%;\n	height: 80px;\n	padding: 0 20px;\n	box-sizing: border-box;\n	color: var(--emp-color);\n	> span {\n		font-size: 14px;\n	}\n	> button {\n		background: #fff;\n		font-size: 14px;\n		text-decoration: underline;\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: flex;\n	flex-direction: column;\n	flex: 1 1 auto;\n	padding: 0 20px;\n\n	> li {\n		flex: 0 0 auto;\n		margin-top: -5px;\n	}\n\n	&:before {\n		position: absolute;\n		top: 0;\n		left: 24px;\n		z-index: 1;\n		display: block;\n		width: 2px;\n		height: 100%;\n		background: #ddd;\n		content: "";\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-left: 20px;\n	margin-bottom: 30px;\n	color: #222;\n	&:before {\n		position: absolute;\n		top: 3px;\n		left: 0;\n		z-index: 2;\n		display: inline-block;\n		width: 11px;\n		height: 11px;\n		border-radius: 50%;\n		background: #222;\n		content: "";\n	}\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding-left: 20px;\n	margin-bottom: 30px;\n\n	",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 20px;\n	overflow: hidden;\n	cursor: pointer;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 16px;\n	height: 12px;\n	margin-right: 5px;\n	background: url(",
        ") no-repeat -249px 0;\n	background-size: 400px 400px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 20px;\n	width: calc(100% - 20px);\n	height: 100%;\n	cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	justify-content: space-between;\n	> div {\n		position: absolute;\n		top: 0;\n		right: 0;\n		z-index: 1;\n		display: flex;\n		align-items: center;\n		gap: 20px;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	width: 12px;\n	height: 12px;\n	background: transparent;\n	&:before {\n		position: absolute;\n		top: 0;\n		left: 50%;\n		display: block;\n		width: 1px;\n		height: 12px;\n		background: #7b7b7b;\n		transform: rotate(-45deg) translateX(-50%);\n		content: "";\n	}\n	&:after {\n		position: absolute;\n		top: 0;\n		right: 50%;\n		display: block;\n		width: 1px;\n		height: 12px;\n		background: #7b7b7b;\n		transform: rotate(-135deg) translateX(-50%);\n		content: "";\n	}\n	> span {\n		font-size: 0;\n		text-indent: -9999em;\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				display: flex;\n				align-items: center;\n				justify-content: center;\n				background: #f3f3f3;\n				&::before {\n					display: block;\n					z-index: 1;\n					width: 63px;\n					height: 50px;\n					background: #f3f3f3 url(",
        ') no-repeat 0 0;\n					background-size: auto 50px;\n					content: "";\n				}\n			'
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				display: flex;\n				align-items: center;\n				justify-content: center;\n				background: #f3f3f3;\n				&::before {\n					display: block;\n					z-index: 1;\n					width: 67px;\n					height: 50px;\n					background: #f3f3f3 url(",
        ') no-repeat -63px 0;\n					background-size: auto 50px;\n					content: "";\n				}\n			'
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	flex: 0 0 auto;\n	width: 120px;\n	height: 80px;\n	overflow: hidden;\n\n	",
        "\n\n	img {\n		width: 120px;\n		height: 80px;\n		object-fit: cover;\n	}\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	flex-direction: column;\n	flex: 1 1 auto;\n	width: 200px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 20px;\n	z-index: 4;\n	display: none;\n	flex-direction: column;\n	align-items: center;\n	justify-content: center;\n	gap: 10px;\n	width: calc(100% - 20px);\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	color: #fff;\n\n	> div {\n		display: flex;\n		gap: 8px;\n\n		> button {\n			width: 100px;\n			padding: 10px 0;\n			border: 1px solid #fff;\n			background: transparent;\n			color: #fff;\n		}\n	}\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: -webkit-box;\n	width: 180px;\n	height: 44px;\n	line-height: 22px;\n	margin-top: 10px;\n	font-size: 15px;\n	color: var(--emp-color);\n	overflow: hidden;\n	text-overflow: ellipsis;\n	-webkit-line-clamp: 2;\n	-webkit-box-orient: vertical;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	margin-top: 20px;\n	gap: 7px;\n\n	> span {\n		font-size: 14px;\n		color: #555;\n	}\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	gap: 5px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n			dt {\n				padding-right: 0;\n				&:after {\n					display: inline-block;\n					width: 1px;\n					height: 10px;\n					margin-left: 10px;\n					background-color: #ddd;\n					content: "";\n				}\n			}\n			dd {\n				margin-left: 10px;\n			}\n		'
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	text-align: left;\n	line-height: 1.2;\n	font-size: 14px;\n\n	dt {\n		position: relative;\n		display: inline-flex;\n		align-items: center;\n		flex: 0 0 auto;\n		padding-right: 10px;\n		color: #222;\n		vertical-align: middle;\n	}\n	dd {\n		display: inline-block;\n		color: #555;\n		vertical-align: middle;\n	}\n\n	",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	flex: 0 0 100px;\n	> button {\n		min-width: 140px;\n	}\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}



var PopupContainer = styled_components_browser_esm["default"].aside.withConfig({
    componentId: "sc-14555b90-0"
})(_templateObject(), function(props) {
    return props.open ? "\n		display: block;\n		" : "\n		display: none;\n		";
}, function(props) {
    return props.show ? "\n	\n	> div {\n			&:first-of-type{\n				\n				animation: dimmfadein 0.3s forwards;\n				display: block;\n			}\n			&:last-of-type{\n				animation: slidein 0.3s 0.3s forwards;\n			}\n	" : "\n			> div {\n			&:first-of-type{\n				animation: dimmfadeout 0.3s forwards;\n			}\n			&:last-of-type{\n				animation: slideout 0.3s forwards;\n			}\n	";
});
var PopupDimm = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-1"
})(_templateObject1());
var PopupBlock = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-2"
})(_templateObject2());
var PopupTop = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-3"
})(_templateObject3());
var PopupArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-4"
})(_templateObject4());
var TxtEmpty = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-5"
})(_templateObject5());
var Title = styled_components_browser_esm["default"].h3.withConfig({
    componentId: "sc-14555b90-6"
})(_templateObject6());
var TopArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-7"
})(_templateObject7());
var HistoryList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-14555b90-8"
})(_templateObject8());
var TitDate = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-14555b90-9"
})(_templateObject9());
var ProdList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-14555b90-10"
})(_templateObject10());
var ProdListItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-14555b90-11"
})(_templateObject11(), function(props) {
    return props.soldout && "\n		> div:first-of-type {\n			display: flex;\n		}\n	";
});
var Prod = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-12"
})(_templateObject12());
var ArrowIcon = styled_components_browser_esm["default"].i.withConfig({
    componentId: "sc-14555b90-13"
})(_templateObject13(), (ico_spr_default()));
var ProdData = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-14"
})(_templateObject14());
var ContainerTag = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-15"
})(_templateObject15());
var ProdDeleteBtn = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-14555b90-16"
})(_templateObject16());
var ThumbImg = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-14555b90-17"
})(_templateObject19(), function(props) {
    if (props.types === "rent") {
        return (0,styled_components_browser_esm.css)(_templateObject17(), (ico_prod_default()));
    }
    if (props.types === "air") {
        return (0,styled_components_browser_esm.css)(_templateObject18(), (ico_prod_default()));
    }
});
var ListView = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-18"
})(_templateObject20());
var BoxSoldout = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-19"
})(_templateObject21());
var TitProd = styled_components_browser_esm["default"].h5.withConfig({
    componentId: "sc-14555b90-20"
})(_templateObject22());
var BoxInfo = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-21"
})(_templateObject23());
var AirIcon = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-14555b90-22"
})(_templateObject24());
var DefinitionList = styled_components_browser_esm["default"].dl.withConfig({
    componentId: "sc-14555b90-23"
})(_templateObject26(), function(props) {
    return props.types === "bar" && (0,styled_components_browser_esm.css)(_templateObject25());
});
var BtnArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-14555b90-24"
})(_templateObject27());


// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 8 modules
var desktop_button = __webpack_require__(36432);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts
var useConfigureAxios = __webpack_require__(83839);
// EXTERNAL MODULE: ./hooks/services/queries/account/useCustomerMe.ts + 1 modules
var useCustomerMe = __webpack_require__(38186);
// EXTERNAL MODULE: ./hooks/services/queries/essential/user/useGetRecently.ts
var useGetRecently = __webpack_require__(40208);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Flag/index.cjs
var Flag = __webpack_require__(29621);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var common_Noimage = __webpack_require__(78860);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/layout/floating/Desktop/Recently.tsx
/* eslint-disable no-case-declarations */ 


















var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
/** pkg_add_evCd_wish */ // const brazeWish = async (evCd: string, detailedUrl: string) => {
// 	const eventDetailPromise = await eventDetailAsync(evCd);
// 	const eventDetail = eventDetailPromise.data.body || null;
// 	const eventPricePromise = await eventPriceAsync(evCd);
// 	const eventPrice = eventPricePromise.data.body || null;
// 	const price = getPrice(eventPrice);
// 	const eventMileagePromise = await eventMileageAsync(evCd);
// 	const eventMileage = eventMileagePromise.data.body || null;
// 	// brazeUtil.pushEvent("pkg_add_evCd_wish", BrazeClickPkgAddEvCdWish(eventDetail, price, eventMileage, detailedUrl));
// };
var getWishData = function(recently) {
    var type = recently.type, detailedUrl = recently.detailedUrl, goodsId = recently.goodsId, webCustId = recently.webCustId, goodsName = recently.goodsName, imgUrl = recently.imgUrl;
    var queries = (0,commonUtil/* getQueryParams */.vl)(decodeURIComponent(detailedUrl));
    var add = {};
    var remove = {};
    switch(type){
        case "PKG":
        case "DMT":
            add = {
                webCustNo: webCustId,
                goodsCd: goodsId.split("-")[0],
                goodsNm: "",
                evCd: goodsId,
                diviCd: "E",
                imageThum: "",
                link: detailedUrl,
                itemCategoryCode: "".concat(goodsId.substring(0, 1) === "K" ? "D" : "P"),
                cityCode: "",
                latestAmount: ""
            };
            break;
        case "HOTEL":
        case "TOUR":
            var _regionCode;
            add = {
                webCustNo: webCustId,
                goodsCd: goodsId,
                goodsNm: goodsName,
                evCd: "",
                diviCd: "",
                imageThum: imgUrl,
                link: detailedUrl,
                itemCategoryCode: type === "HOTEL" ? "IC02" : "IC04",
                cityCode: (_regionCode = queries.regionCode) !== null && _regionCode !== void 0 ? _regionCode : "",
                latestAmount: ""
            };
            break;
        default:
            break;
    }
    remove = {
        wishList: [
            (0,_object_spread/* default */.Z)({}, add)
        ]
    };
    return {
        add: add,
        remove: remove
    };
};
var InfoByType = function(param) {
    var type = param.type, information = param.information;
    var infoArr = information.split(";");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (type === "PKG" || type === "DMT") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AirIcon, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://static.ybtour.com/images/air/".concat(infoArr[6], ".png"),
                                alt: infoArr[7]
                            }),
                            infoArr[7]
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(dayjs_min_default()(infoArr[0]).format("YY.MM.DD")).concat(infoArr[1])
                    })
                ]
            }),
            type === "RENT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "".concat(dayjs_min_default()(infoArr[0]).format("YY.MM.DD")).concat(infoArr[1], " ").concat(infoArr[2]),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "~".concat(dayjs_min_default()(infoArr[3]).format("YY.MM.DD")).concat(infoArr[4], " ").concat(infoArr[5])
                    ]
                })
            }),
            type === "AIR" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, {
                children: infoArr.length >= 7 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(infoArr[0]).concat(infoArr[1], "~").concat(infoArr[2]).concat(infoArr[3])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefinitionList, {
                            types: "bar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    children: infoArr[4]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    children: "".concat(infoArr[5], ", ").concat(infoArr[6])
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(infoArr[0]).concat(infoArr[1])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefinitionList, {
                            types: "bar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    children: infoArr[3]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    children: "".concat(infoArr[4], ", ").concat(infoArr[5])
                                })
                            ]
                        })
                    ]
                })
            }),
            type === "HOTEL" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(dayjs_min_default()(infoArr[0]).format("YY.MM.DD")).concat(infoArr[1], "~").concat(dayjs_min_default()(infoArr[2]).format("YY.MM.DD")).concat(infoArr[3])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefinitionList, {
                        types: "bar",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: infoArr[4]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: "".concat(infoArr[5], ", ").concat(infoArr[6])
                            })
                        ]
                    })
                ]
            }),
            type === "TOUR" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, {})
        ]
    });
};
var FlagByType = function(param) {
    var type = param.type, category = param.category;
    var flagArr = category.split(";");
    return type === "PKG" || type === "DMT" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
        $type: "product",
        $flag: flagArr[0],
        text: flagArr[1]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
        $type: "product",
        $flag: type.toLowerCase(),
        text: category
    });
};
/** 찜하기 */ var WishByType = function(recently) {
    var type = recently.type, evCd = recently.goodsId, wishListYn = recently.wishListYn, isSignin = recently.isSignin;
    // 렌트카 | 항공 비노출
    if (type === "RENT" || type === "AIR") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var isWish = wishListYn === "Y";
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var addWish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "POST", _tmp.data = getWishData(recently).add, _tmp)).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if (result.data.code === "0000") {
                            alert("찜한 상품으로 등록되었습니다.");
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useGetRecently"
                            ], _tmp1.type = "active", _tmp1));
                        } else {
                            throw new Error();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function addWish() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeWish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isWish) return [
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "DELETE", _tmp.data = getWishData(recently).remove, _tmp)).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if (result.data.code === "0000") {
                            alert("찜한 상품이 삭제되었습니다.");
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useGetRecently"
                            ], _tmp1.type = "active", _tmp1));
                        } else {
                            throw new Error();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function removeWish() {
            return _ref.apply(this, arguments);
        };
    }();
    var wish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!isWish) {
                    /** 위시리스트 등록 */ addWish();
                /** braze */ // if (type === "PKG" || type === "DMT") brazeWish(evCd, detailedUrl);
                } else {
                    /** 위시리스트 삭제 */ removeWish();
                }
                return [
                    2
                ];
            });
        });
        return function wish(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    if (!evCd) throw new Error("필수 파라미터 누락");
                    if (!isSignin) {
                        if (confirm("로그인이 필요한 서비스입니다.")) LoginUtil.login();
                    } else {
                        wish(e);
                    }
                } catch (e1) {
                    ;
                    alert("오류가 발생하였습니다. <br/>".concat(e1));
                }
                return [
                    2
                ];
            });
        });
        return function onClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
        icon: "wishList",
        onClick: onClick,
        isActive: isWish,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "상품 찜하기"
        })
    });
};
var RecentlyComponent = function(props) {
    var ref, ref1, ref2, ref3;
    var open = props.open, show = props.show, closeOpen = props.closeOpen, closeShow = props.closeShow;
    (0,react.useEffect)(function() {
        document.body.style.overflow = show ? "hidden" : "";
    }, [
        show
    ]);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /** 로그인 정보 */ var signin = (0,useCustomerMe/* default */.ZP)({
        throwOnError: false
    });
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
    var isSignin = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.body.nonUser) === false;
    /** 최근 본 상품 ID */ var userId = (0,commonUtil/* getCookie */.ej)("userId") || (window.ensureUserHasUniqueId ? window.ensureUserHasUniqueId() : "");
    /** 최근 본 리스트 */ var recentlyListFetch = (0,useGetRecently/* default */.Z)(userId, webCustNo, {
        enabled: !signin.isFetching && !!userId,
        throwOnError: false
    });
    var recentlyList = ((ref2 = recentlyListFetch.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.body) === null || ref3 === void 0 ? void 0 : ref3.productResultList) || [];
    // viewDate 기준 내림차순 정렬
    var recentlyData = (0,react.useMemo)(function() {
        var sortedList = (0,_to_consumable_array/* default */.Z)(recentlyList).sort(function(a, b) {
            if (a.viewDate < b.viewDate) return 1;
            if (a.viewDate > b.viewDate) return -1;
            return 0;
        });
        return sortedList.reduce(function(acc, cur) {
            var date = dayjs_min_default()(cur.viewDate).format("YYYY.MM.DD");
            acc[date] = acc[date] || [];
            acc[date].push(cur);
            return acc;
        }, {});
    }, [
        recentlyList
    ]);
    /** 최근 본 삭제 */ var deleteRecently = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(recently) {
            var data, _tmp, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        data = recently ? (_tmp.productList = [
                            (0,_object_spread/* default */.Z)({}, recently)
                        ], _tmp) : (_tmp1.productList = [
                            {
                                userId: userId,
                                webCustId: webCustNo,
                                goodsId: ""
                            }
                        ], _tmp1);
                        _tmp2 = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp2.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/user/recentlyViewed"), _tmp2.method = "DELETE", _tmp2.data = data, _tmp2)).then(function(res) {
                                if (res.data.code === "0000") {
                                    /* 데이터 최신화 */ queryClient.refetchQueries({
                                        queryKey: [
                                            "useGetRecently"
                                        ],
                                        type: "active"
                                    });
                                } else {
                                    throw new Error();
                                }
                            }).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteRecently(recently) {
            return _ref.apply(this, arguments);
        };
    }();
    /** 찜목록 버튼 */ var mypageWishButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var nextUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                nextUrl = "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/wishGoods.yb");
                if (isSignin) {
                    window.location.href = nextUrl;
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (confirm("로그인이 필요한 서비스입니다.")) LoginUtil.login();
                }
                return [
                    2
                ];
            });
        });
        return function mypageWishButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupContainer, {
        open: open,
        show: show,
        "data-show": String(show),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupDimm, {
                onClick: closeShow,
                onAnimationEnd: function() {
                    return !show && closeOpen();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupTop, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                                children: [
                                    "최근 본 상품",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: recentlyList.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                                        onClick: mypageWishButton,
                                        types: "base",
                                        width: "basic",
                                        size: "default",
                                        text: "찜목록"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* PopupCloseButton */.sz, {
                                        onClose: closeShow
                                    })
                                ]
                            })
                        ]
                    }),
                    recentlyList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TxtEmpty, {
                        children: "최근 본 상품이 없습니다"
                    }),
                    recentlyList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupArea, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopArea, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "최대 30개까지 조회가 가능합니다."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            if (confirm("최근 본 상품 리스트를 모두 삭제합니다.")) deleteRecently();
                                        },
                                        children: "전체 삭제"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryList, {
                                children: Object.keys(recentlyData).map(function(date) {
                                    var recentlyArr = recentlyData[date];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitDate, {
                                                children: "".concat(dayjs_min_default()(date).format("MM.DD"), "(").concat(daykor[dayjs_min_default()(date).day()], ")")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdList, {
                                                children: recentlyArr.map(function(item, index) {
                                                    var information = item.information, goodsName = item.goodsName, category = item.category, type = item.type, detailedUrl = item.detailedUrl, soldoutYn = item.soldoutYn, wishListYn = item.wishListYn;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProdListItem, {
                                                        soldout: soldoutYn === "Y",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxSoldout, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "판매 종료"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                onClick: function() {
                                                                                    return window.location.href = item.changedUrl;
                                                                                },
                                                                                children: "일정 변경"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                onClick: function() {
                                                                                    return deleteRecently(item);
                                                                                },
                                                                                children: "삭제"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Prod, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbImg, {
                                                                        types: type.toLowerCase(),
                                                                        children: item.imgUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Noimage/* Noimage */.T, {
                                                                            width: "120px",
                                                                            height: "80px",
                                                                            src: item.imgUrl,
                                                                            alt: ""
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListView, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerTag, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagByType, {
                                                                                        type: type,
                                                                                        category: category
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WishByType, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                                                                wishListYn: wishListYn,
                                                                                                isSignin: isSignin
                                                                                            })),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdDeleteBtn, {
                                                                                                onClick: function() {
                                                                                                    return deleteRecently(item);
                                                                                                },
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: "최근 본 상품 삭제"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitProd, {
                                                                                children: goodsName
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoByType, {
                                                                                type: type,
                                                                                information: information
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdData, {
                                                                onClick: function() {
                                                                    return location.href = detailedUrl;
                                                                }
                                                            })
                                                        ]
                                                    }, "".concat(item.goodsId).concat(index));
                                                })
                                            })
                                        ]
                                    }, date);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Recently = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentlyComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var Desktop_Recently = (Recently);

// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
;// CONCATENATED MODULE: ./framework/ui/desktop/header/index.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	a {\n		position: absolute;\n		display: block;\n		width: 1px;\n		height: 1px;\n		margin-bottom: -1px;\n		left: 0;\n		top: 0;\n		z-index: 100;\n		font-size: 14px;\n		font-weight: bold;\n		color: #fff;\n		text-align: center;\n		overflow: hidden;\n	}\n\n	&:focus {\n		width: 100%;\n		height: auto;\n		padding: 5px 0;\n		background: #333;\n	}\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	letter-spacing: -0.02em;\n\n	button {\n		cursor: pointer;\n		overflow: visible;\n		border: 0 none;\n		background-color: transparent;\n		font-family: "PT-medium", Sans-serif;\n		font-weight: normal;\n		font-size: 15px;\n		color: #555;\n		text-indent: 0;\n	}\n	h1 a {\n		display: block;\n	}\n	h1 a img {\n		width: 165px;\n		height: 44px;\n		vertical-align: top;\n	}\n'
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	height: 70px;\n	background-color: #fff;\n	z-index: 11;\n\n	a {\n		display: block;\n		height: 100%;\n	}\n\n	div {\n		position: relative;\n		width: 1200px;\n		height: 70px;\n		margin: 0 auto;\n	}\n\n	img {\n		width: 100%;\n		height: 100%;\n		vertical-align: top;\n	}\n"
    ]);
    header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 0;\n	top: 50%;\n	width: 25px;\n	height: 25px;\n	padding: 0;\n	margin: 0;\n	border: 0;\n	background: none;\n	transform: translateY(-50%);\n\n	&:before,\n	&:after {\n		position: absolute;\n		right: -3px;\n		height: 1px;\n		width: 32px;\n		background: #000;\n		border-radius: 1px;\n		content: "";\n	}\n\n	&:before {\n		transform: rotate(45deg);\n	}\n\n	&:after {\n		transform: rotate(-45deg);\n	}\n'
    ]);
    header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding-top: 30px;\n	background-color: #fff;\n	z-index: 15;\n"
    ]);
    header_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	background-color: #fff;\n	box-sizing: border-box;\n	border-bottom: 1px solid #222;\n"
    ]);
    header_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	width: 1200px;\n	padding: 20px 0 10px;\n	margin: 0 auto;\n\n	> div:first-child {\n		display: flex;\n		gap: 30px;\n		align-items: center;\n	}\n\n	h1 {\n		line-height: 1;\n	}\n"
    ]);
    header_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	gap: 40px;\n	align-items: center;\n\n	ul {\n		display: flex;\n	}\n	li {\n		position: relative;\n		padding-right: 13px;\n		margin-right: 10px;\n		line-height: 1.6;\n\n		&:after {\n			position: absolute;\n			right: 0;\n			top: 50%;\n			display: inline-block;\n			width: 3px;\n			height: 3px;\n			background-color: #ccc;\n			transform: translateY(-50%);\n			content: "";\n		}\n\n		&:last-child {\n			padding-right: 0;\n			margin-right: 0;\n		}\n\n		&:last-child::after {\n			display: none;\n		}\n	}\n	a {\n		color: #111;\n		font-size: 17px;\n		box-sizing: border-box;\n	}\n'
    ]);
    header_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function header_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 10px;\n\n	a {\n		box-sizing: border-box;\n	}\n"
    ]);
    header_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function header_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 36px;\n	height: 36px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_mypage.png) center / cover no-repeat;\n"
    ]);
    header_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function header_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    header_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function header_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: block;\n	padding: 20px 15px;\n	font-family: "PT-regular";\n	font-size: 17px;\n	color: #555;\n	line-height: 1;\n'
    ]);
    header_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function header_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: -2px;\n	left: 50%;\n	height: 16px;\n	width: 40px;\n	border-radius: 13px;\n	background-color: #ff5c46;\n	color: #fff;\n	font-size: 11px;\n	text-align: center;\n	font-family: "PT-bold";\n	line-height: 1.6;\n	transform: translateX(-50%);\n\n	&:after {\n		position: absolute;\n		bottom: -3px;\n		left: 50%;\n		transform: translateX(-50%);\n		width: 0px;\n		height: 0px;\n		border-top: 4px solid #ff5c46;\n		border-left: 4px solid transparent;\n		border-right: 4px solid transparent;\n		content: "";\n	}\n'
    ]);
    header_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function header_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 57px;\n	left: 0;\n	width: 100%;\n	background-color: #fff;\n	border-top: 1px solid #222;\n	visibility: hidden;\n\n	&:has(li)::before {\n		position: absolute;\n		top: 49px;\n		left: 0;\n		width: 100%;\n		height: 1px;\n		background-color: #ddd;\n		content: "";\n	}\n'
    ]);
    header_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function header_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 0 auto;\n\n	> ul {\n		display: flex;\n	}\n"
    ]);
    header_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function header_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n\n	> ul {\n		display: flex;\n		width: 1200px;\n		margin: 0 auto;\n\n		> li:first-child {\n			margin-left: -15px;\n		}\n	}\n\n	li:hover {\n		",
        " {\n			visibility: visible;\n		}\n\n		",
        " {\n			color: #222;\n			font-weight: bold;\n		}\n	}\n"
    ]);
    header_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function header_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	bottom: 0;\n	width: 100%;\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	z-index: 10;\n"
    ]);
    header_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function header_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	left: 0;\n	top: 50px;\n	display: none;\n	width: 100%;\n	min-height: 450px;\n	height: 450px;\n	background-color: #fff;\n	z-index: 10;\n"
    ]);
    header_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function header_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding-right: 20px;\n\n	&:last-child {\n		padding-right: 0;\n	}\n\n	> a {\n		position: relative;\n		display: flex;\n		align-items: center;\n		height: 50px;\n		font-size: 15px;\n		color: #555;\n		cursor: pointer;\n	}\n\n	&:hover {\n		> a {\n			font-weight: bold;\n			color: #222;\n\n			&:after {\n				position: absolute;\n				bottom: 1px;\n				left: 50%;\n				transform: translateX(-50%);\n				display: block;\n				width: 100%;\n				height: 2px;\n				background-color: #222;\n				height: 2px;\n				content: "";\n			}\n		}\n\n		',
        ", ",
        " {\n			display: block;\n		}\n	}\n"
    ]);
    header_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function header_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	float: right;\n	display: flex;\n	gap: 15px;\n	margin-top: -33px;\n	font-size: 14px;\n	color: #777;\n\n	li:hover {\n		color: #4567ad;\n	}\n"
    ]);
    header_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function header_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    header_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function header_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: block;\n	font-family: "PT-medium";\n	font-size: 18px;\n	color: #4567ad;\n\n	a {\n		margin-left: 7px;\n		color: #111;\n	}\n'
    ]);
    header_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function header_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding: 30px;\n	flex-basis: 300px;\n	box-sizing: border-box;\n\n	&:first-child {\n		flex-grow: 1;\n		background-color: #f5f5f5;\n	}\n\n	&:first-child:after {\n		display: none;\n	}\n\n	&:after {\n		position: absolute;\n		right: 0;\n		top: 0;\n		width: 1px;\n		height: 100%;\n		background-color: #ddd;\n		content: "";\n	}\n\n	ul {\n		display: flex;\n		flex-direction: column;\n		gap: 20px;\n		flex-wrap: wrap;\n		height: 340px;\n		width: 100%;\n		margin-top: 20px;\n	}\n\n	li {\n		width: 240px;\n		line-height: 1;\n	}\n'
    ]);
    header_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function header_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	li a {\n		display: block;\n		width: 100%;\n		align-items: center;\n		font-size: 15px;\n		color: #555;\n		text-overflow: ellipsis;\n		white-space: nowrap;\n		-o-text-overflow: ellipsis;\n		overflow: hidden;\n\n		&:hover {\n			color: #111;\n			text-decoration: underline;\n		}\n	}\n"
    ]);
    header_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function header_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	width: 340px;\n	height: 46px;\n	padding: 0 25px 0 20px;\n	border-radius: 30px;\n	border: 2px solid #ffcb31;\n	box-sizing: border-box;\n\n	a {\n		display: block;\n		width: 100%;\n		padding: 12px 0;\n		color: #999;\n		font-size: 15px;\n		",
        "\n	}\n"
    ]);
    header_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function header_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 23px;\n	height: 22px;\n	flex-shrink: 0;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/btn_search.png) no-repeat;\n	z-index: 1;\n"
    ]);
    header_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function header_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	width: 100%;\n	height: 30px;\n	background-color: #f3f3f3;\n	box-sizing: border-box;\n	font-size: 13px;\n	color: #555;\n\n	ul {\n		display: flex;\n		gap: 20px;\n		align-items: center;\n		justify-content: end;\n	}\n\n	li:hover {\n		color: #222;\n	}\n\n	a {\n		line-height: 30px;\n	}\n"
    ]);
    header_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function header_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    header_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-right: 12px;\n	color: #111;\n	cursor: pointer;\n	line-height: 1.6;\n\n	&:after {\n		content: "";\n		position: absolute;\n		top: 50%;\n		right: 0;\n		border-top: 4px solid #222;\n		border-left: 3px solid transparent;\n		border-right: 3px solid transparent;\n		transform: translateY(-50%);\n	}\n\n	',
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 25px;\n	right: -20px;\n	z-index: 1;\n	display: flex;\n	flex-direction: column;\n	gap: 12px;\n	width: 110px;\n	padding: 15px 15px 20px;\n	border: 1px solid #222;\n	border-radius: 3px;\n	background-color: #fff;\n	font-size: 13px;\n	color: #555;\n	box-sizing: border-box;\n\n	&:before {\n		content: "";\n		position: absolute;\n		top: -8px;\n		right: 50%;\n		width: 7px;\n		height: 7px;\n		background: #fff;\n		border-right: 1px solid #222;\n		border-bottom: 1px solid #222;\n		transform: rotate(-135deg) translateX(-50%);\n	}\n\n	a {\n		display: block;\n		line-height: 1;\n\n		&:hover {\n			color: #4567ad;\n			text-decoration: underline;\n		}\n	}\n'
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}




var SkipNavi = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-0"
})(header_templateObject());
var HeaderWrap = styled_components_browser_esm["default"].header.withConfig({
    componentId: "sc-f9e6aa67-1"
})(header_templateObject1());
var TopBanner = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-2"
})(header_templateObject2());
var BtnBannerClose = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-f9e6aa67-3"
})(header_templateObject3());
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-4"
})(header_templateObject4());
var Gnb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-5"
})(header_templateObject5());
var TopNavWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-6"
})(header_templateObject6());
var UtileLinks = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-7"
})(header_templateObject7());
var BtnGroup = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-8"
})(header_templateObject8());
var BtnMypage = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-f9e6aa67-9"
})(header_templateObject9());
var BtnRecent = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-f9e6aa67-10"
})(header_templateObject10(), function(props) {
    return props.$hasRecent ? "width: 34px;\n				height: 34px;\n				border: 1px solid #bbb;\n				border-radius: 8px;\n				overflow: hidden;\n\n				img {\n					width: 100%;\n					height: 100%;\n				}\n				" : "\n				width: 36px;\n				height: 36px;\n				border: none;\n				background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_recent.png) center / cover no-repeat;\n			";
});
var GnbItem = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-f9e6aa67-11"
})(header_templateObject11());
var IconBadge = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-f9e6aa67-12"
})(header_templateObject12());
var Lnb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-13"
})(header_templateObject13());
var LnbWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-14"
})(header_templateObject14());
var Navi = styled_components_browser_esm["default"].nav.withConfig({
    componentId: "sc-f9e6aa67-15"
})(header_templateObject15(), Lnb, GnbItem);
var Dim = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-16"
})(header_templateObject16());
var Category = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-17"
})(header_templateObject17());
var LnbItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-f9e6aa67-18"
})(header_templateObject18(), Dim, Category);
var EventNavi = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-f9e6aa67-19"
})(header_templateObject19());
var CategoryWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-20"
})(header_templateObject20());
var CategorySubtitle = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-f9e6aa67-21"
})(header_templateObject21());
var CategoryArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-22"
})(header_templateObject22());
var List = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-f9e6aa67-23"
})(header_templateObject23());
var SearchWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-24"
})(header_templateObject24(), (0,desktop_text/* Ellipsis */.mH)(1));
var BtnSearch = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-f9e6aa67-25"
})(header_templateObject25());
var GnbUtil = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-26"
})(header_templateObject26());
var GnbUtilWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-27"
})(header_templateObject27());
var Login = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-f9e6aa67-28"
})(_templateObject28(), function(props) {
    return props.$isShow && "\n		&:after {\n			border-top: 0;\n			border-bottom: 4px solid #222;\n		}\n	";
});
var LoginTooltip = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9e6aa67-29"
})(_templateObject29());
var Header = function() {
    var ref = useState(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var tooltipRef = useRef(null);
    var ref1 = useState(false), isDim = ref1[0], setIsisDim = ref1[1];
    var loginRef = useRef(null);
    var centerRef = useRef(null);
    var depth2WrapRef = useRef(null);
    var naviWrapRef = useRef(null);
    // 로그인시 나오는 툴팁
    var handleClickOutside = function(event) {
        var ref, ref1;
        var target = event.target;
        if (target && !((ref = tooltipRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) && !((ref1 = loginRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) {
            setShowTooltip(false);
        }
    };
    useEffect(function() {
        if (showTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showTooltip
    ]);
    var handleClick = function() {
        setShowTooltip(function(prev) {
            return !prev;
        });
    };
    // 2 Depth에 3 Depth가 있을 경우 dim 보여주기
    var handleMouseEnter = function() {
        return setIsisDim(true);
    };
    var handleMouseLeave = function() {
        return setIsisDim(false);
    };
    // 2 Depth가 center로 설정 될 경우
    useEffect(function() {
        var updatePosition = function() {
            if (!centerRef.current || !depth2WrapRef.current || !naviWrapRef.current) return;
            var centerElement = centerRef.current;
            var depth2Wrap = depth2WrapRef.current;
            var naviWrap = naviWrapRef.current;
            var position = centerElement.getBoundingClientRect();
            var naviPosition = naviWrap.getBoundingClientRect();
            var totalWidth = 0;
            // 자식 요소들의 전체 width 값을 구하기
            Array.from(depth2Wrap.children).forEach(function(child) {
                var childElement = child;
                totalWidth += childElement.offsetWidth;
            });
            depth2Wrap.style.paddingLeft = "".concat(position.left - naviPosition.left - totalWidth / 2 + position.width / 2, "px");
        };
        // 초기 위치 설정
        updatePosition();
        // 브라우저가 리사이즈될 때마다 위치 업데이트
        window.addEventListener("resize", updatePosition);
        return function() {
            window.removeEventListener("resize", updatePosition);
        };
    }, []);
    return /*#__PURE__*/ _jsxs(HeaderWrap, {
        children: [
            /*#__PURE__*/ _jsx(TopBanner, {
                style: {
                    backgroundColor: "#fdebe9"
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: "#",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner.jpg",
                                alt: "배너 이미지"
                            })
                        }),
                        /*#__PURE__*/ _jsx(BtnBannerClose, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "배너 닫기"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsxs(SkipNavi, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "#content",
                                children: "본문 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb",
                                children: "카테고리 메뉴 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb-login",
                                children: "로그인 메뉴 바로가기"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Gnb, {
                        children: [
                            /*#__PURE__*/ _jsxs(TopNavWrap, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("h1", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "/index.yb",
                                                    children: /*#__PURE__*/ _jsx("img", {
                                                        src: "https://cimgcdn.ybtour.co.kr/common/logo/logo_l.png",
                                                        alt: "노랑풍선"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs(SearchWrap, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "#",
                                                        children: "검색 프로모션 영역 텍스트"
                                                    }),
                                                    /*#__PURE__*/ _jsx(BtnSearch, {
                                                        type: "button",
                                                        onClick: function() {
                                                            location.href = "https://pkg.ybtour.co.kr/common/searchGoods.yb";
                                                        },
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: "검색"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(UtileLinks, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("ul", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "베스트"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "마감임박"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "출발보장"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "썸머특가"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "당장노랑"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(BtnGroup, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(BtnMypage, {
                                                        href: "https://pkg.ybtour.co.kr/mypage/index.yb",
                                                        children: /*#__PURE__*/ _jsx(Accessibility, {
                                                            children: "마이페이지"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(BtnRecent, {
                                                        href: "#",
                                                        $hasRecent: true,
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Accessibility, {
                                                                children: "최근본"
                                                            }),
                                                            /*#__PURE__*/ _jsx("img", {
                                                                src: "https://dimgcdn.ybtour.co.kr/TN/99/99897c62991b42e78a3c3fad024dce69.tn.410x280.jpg",
                                                                alt: "상품 이미지"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Navi, {
                                children: /*#__PURE__*/ _jsxs("ul", {
                                    ref: naviWrapRef,
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx(GnbItem, {
                                                    href: "#",
                                                    children: "해외패키지"
                                                }),
                                                /*#__PURE__*/ _jsx(Lnb, {
                                                    children: /*#__PURE__*/ _jsxs(LnbWrap, {
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "유럽"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 유럽"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_6"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_7"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_8"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_9"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "테마별"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "6"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "프로모션"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가 프로모션 프로모션 프로모션 프로모션"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "아시아나 항공 유럽 SUMMER 특가"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "유럽의 숨겨진 보물, HENANN RESORT"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "상상 이상의 행복한 허니문을 위한 Fourseasons in France"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "동남아"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역별",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 동남아"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_6"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_7"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_8"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_9"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_10"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_11"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_12"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_13"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_14"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_15"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_16"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_17"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_18"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "테마별"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "6"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "프로모션"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "창립 21주년 기념, 동남아 5만원 할인!"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "격리없이 떠나는 푸켓"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "샹그릴라&요트선셋투어 in 싱가포르"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "동남아! 할인챌린지 앙코르전"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "아시아나 A380 타고 떠나는 방콕/파타야"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "일본"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역별",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 일본"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(CategoryArea, {}),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "프로모션"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "오사카 여행 200% 즐기는 방법"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "나만 알고싶은 소도시로, 단풍여행"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "겨울시즌 온천여행 오이타"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "황금연휴 출발확정"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "MZ 취향저격 특급호텔 호캉스 MZ 취향저격 특급호텔 호캉스"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "괌/사이판"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역별",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 괌/사이판"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "테마별"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(List, {
                                                                                                    children: /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "여행에 테마를 더하다"
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(CategoryArea, {})
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "호주/뉴질랜드"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "미주/캐나다/하와이"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "중남미/아프리카"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "대만/홍콩/마카오"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "중국/몽골/중아아시아"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "부산/지방 출발"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs(EventNavi, {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("li", {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "기획전"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("li", {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "이벤트"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("li", {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "홈쇼핑"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "에어텔"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs(GnbItem, {
                                                href: "#",
                                                children: [
                                                    /*#__PURE__*/ _jsx(IconBadge, {
                                                        children: "NEW"
                                                    }),
                                                    "허니문"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs(GnbItem, {
                                                href: "#",
                                                children: [
                                                    /*#__PURE__*/ _jsx(IconBadge, {
                                                        children: "HOT"
                                                    }),
                                                    "골프"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            ref: centerRef,
                                            children: [
                                                /*#__PURE__*/ _jsx(GnbItem, {
                                                    href: "#",
                                                    children: "테마/크루즈"
                                                }),
                                                /*#__PURE__*/ _jsx(Lnb, {
                                                    children: /*#__PURE__*/ _jsx(LnbWrap, {
                                                        children: /*#__PURE__*/ _jsxs("ul", {
                                                            ref: depth2WrapRef,
                                                            children: [
                                                                /*#__PURE__*/ _jsx(LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "테마여행"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "크루즈"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "프리미엄"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "국내여행"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "항공"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "호텔"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "투어&티켓"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "렌터카"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "기업/단체"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(GnbUtil, {
                                id: "gnb-login",
                                children: /*#__PURE__*/ _jsx(GnbUtilWrap, {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsxs(Login, {
                                                onClick: handleClick,
                                                $isShow: showTooltip,
                                                ref: loginRef,
                                                children: [
                                                    "김노랑 님",
                                                    showTooltip && /*#__PURE__*/ _jsxs(LoginTooltip, {
                                                        ref: tooltipRef,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "개인정보 수정"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "비밀번호 변경"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "SNS 연결 설정"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "#",
                                                    children: "로그아웃"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/mypage/resvInfo.yb",
                                                    children: "예약확인/결제"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                                    children: "고객센터"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isDim && /*#__PURE__*/ _jsx(Dim, {})
        ]
    });
};

/* harmony default export */ var header = ((/* unused pure expression or super */ null && (Header)));

// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
;// CONCATENATED MODULE: ./components/layout/header/Desktop/Gnb.tsx










var Lv3List = function(props) {
    var lv1 = props.lv1, lv2 = props.lv2, lv3List = props.lv3List, proMenuList = props.proMenuList, taggingClick = props.taggingClick;
    var localLv3 = lv3List.filter(function(o) {
        return o.locTypeCd !== "T" && o.homeYn === "Y";
    }) || [];
    var themaLv3 = lv3List.filter(function(o) {
        return o.locTypeCd === "T" && o.homeYn === "Y";
    }) || [];
    var promotionLv3 = proMenuList.filter(function(o) {
        return o.dspSid === lv2.dspSid;
    }) || [];
    var isLv3 = lv1.areaMainYn === "Y";
    var isLocalType = lv2.gnbTypeCd === "L";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLv3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryArea, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySubtitle, {
                                    children: [
                                        "지역",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
                                            href: lv2.dspUrl || "#",
                                            onClick: function() {
                                                return taggingClick(lv2);
                                            },
                                            children: [
                                                "[",
                                                lv1.dspNm,
                                                "] ",
                                                lv2.dspNm
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                    children: localLv3.map(function(local, localIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                href: local.dspUrl || "#",
                                                target: (0,commonUtil/* getTarget */.U9)(local.webMenuTarget),
                                                onClick: function(e) {
                                                    taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, local), {
                                                        dspOrder: localIndex + 1
                                                    }));
                                                },
                                                children: local.dspNm
                                            })
                                        }, local.dspSid + localIndex);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryArea, {
                            children: !isLocalType && themaLv3.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySubtitle, {
                                        children: "테마별"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                        children: themaLv3.map(function(thema, themaIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: thema.dspUrl || "#",
                                                    target: (0,commonUtil/* getTarget */.U9)(thema.webMenuTarget),
                                                    onClick: function(e) {
                                                        taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thema), {
                                                            dspOrder: themaIndex + 1
                                                        }));
                                                    },
                                                    children: thema.dspNm
                                                })
                                            }, thema.dspSid + themaIndex);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryArea, {
                            children: promotionLv3.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySubtitle, {
                                        children: "프로모션"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                        children: promotionLv3.map(function(promotion, promotionIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: promotion.dspUrl || "#",
                                                    target: (0,commonUtil/* getTarget */.U9)(promotion.webMenuTarget),
                                                    onClick: function(e) {
                                                        taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promotion), {
                                                            dspOrder: promotionIndex + 1
                                                        }));
                                                    },
                                                    children: promotion.subDspNm
                                                })
                                            }, promotion.dspSid + promotionIndex);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var Lv2List = function(props) {
    var globalMenu = props.globalMenu, hoverLv1 = props.hoverLv1, handelEnterLv2 = props.handelEnterLv2, handelLeaveLv2 = props.handelLeaveLv2, taggingClick = props.taggingClick;
    var menuLv1List = globalMenu.menuLv1List, menuLv2List = globalMenu.menuLv2List, menuLv3List = globalMenu.menuLv3List, proMenuList = globalMenu.proMenuList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuLv2List.filter(function(o) {
            return o.dspSidHi === hoverLv1 && o.homeYn === "Y";
        }).map(function(lv2, lv2Index) {
            var lv1 = menuLv1List.find(function(o) {
                return o.dspSid === lv2.dspSidHi;
            }); // 1depth
            var lv3List = menuLv3List.filter(function(o) {
                return o.dspSidHi === lv2.dspSid && o.homeYn === "Y";
            }) || [];
            var isLv3 = lv1.areaMainYn === "Y";
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LnbItem, {
                onMouseEnter: function() {
                    return isLv3 && handelEnterLv2();
                },
                onMouseLeave: function() {
                    return isLv3 && handelLeaveLv2();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                        href: lv2.dspUrl || "#",
                        target: (0,commonUtil/* getTarget */.U9)(lv2.webMenuTarget),
                        onClick: function(e) {
                            taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, lv2), {
                                dspOrder: lv2Index + 1
                            }));
                        },
                        children: lv2.dspNm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Lv3List, {
                        lv1: lv1,
                        lv2: lv2,
                        lv3List: lv3List,
                        proMenuList: proMenuList,
                        taggingClick: taggingClick
                    })
                ]
            }, lv2.dspSid + lv2Index);
        })
    });
};
var GNBComponent = function(props) {
    var ref;
    var handleDim = props.handleDim;
    /** 메뉴 관련 API */ var globalMenuFetch = (0,useGlobalMenu/* default */.Z)();
    var globalMenu = (ref = globalMenuFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var menuLv1List = globalMenu === null || globalMenu === void 0 ? void 0 : globalMenu.menuLv1List;
    var subMenuList = globalMenu === null || globalMenu === void 0 ? void 0 : globalMenu.subMenuList;
    var centerRef = (0,react.useRef)([]);
    var depth2WrapRef = (0,react.useRef)([]);
    var naviWrapRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), hoverLv1 = ref1[0], setHoverLv1 = ref1[1]; // dspSid
    var ref2 = (0,react.useState)(0), hoverIndex = ref2[0], setHoverIndex = ref2[1];
    var handleEnterLv1 = function(index, dspSid) {
        setHoverLv1(dspSid);
        setHoverIndex(index);
    };
    // LV2 에 LV3 가 있을 경우 dim 보여주기
    var handelEnterLv2 = function() {
        return handleDim(true);
    };
    var handelLeaveLv2 = function() {
        return handleDim(false);
    };
    (0,react.useEffect)(function() {
        if (!menuLv1List) return;
        var isAlign = menuLv1List.some(function(v) {
            return v.dspSid === hoverLv1 && v.align === "N";
        });
        // 2 Depth가 center로 설정 될 경우 (align === "N")
        if (!isAlign || !hoverIndex || !centerRef.current || !depth2WrapRef.current || !naviWrapRef.current) return;
        var centerElement = centerRef.current[hoverIndex];
        var depth2Wrap = depth2WrapRef.current[hoverIndex];
        var naviWrap = naviWrapRef.current;
        var position = centerElement.getBoundingClientRect();
        var naviPosition = naviWrap.getBoundingClientRect();
        // // 자식 요소들의 전체 width 값을 구하기
        var totalWidth = Array.from(depth2Wrap.children).reduce(function(total, child) {
            var childElement = child;
            return total + childElement.offsetWidth;
        }, 0);
        depth2Wrap.style.paddingLeft = "".concat(position.left - naviPosition.left - totalWidth / 2 + position.width / 2, "px");
    }, [
        hoverLv1
    ]);
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("gnb_click").taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navi, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            ref: naviWrapRef,
            children: menuLv1List && menuLv1List.filter(function(o) {
                return o.homeYn === "Y";
            }).map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    ref: function(el) {
                        return centerRef.current[index] = el;
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GnbItem, {
                            href: item.dspUrl || "#",
                            target: (0,commonUtil/* getTarget */.U9)(item.webMenuTarget),
                            onClick: function(e) {
                                taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    dspOrder: index + 1
                                }));
                                (0,commonUtil/* onClickSSO */.Zy)(e, item.dspUrl || "#");
                            },
                            onMouseEnter: function() {
                                return handleEnterLv1(index, item.dspSid);
                            },
                            children: [
                                item.iconYn === "Y" && item.iconType && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBadge, {
                                    children: item.iconType
                                }),
                                item.dspNm
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lnb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LnbWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        ref: function(el) {
                                            return depth2WrapRef.current[index] = el;
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lv2List, {
                                            globalMenu: globalMenu,
                                            hoverLv1: hoverLv1,
                                            handelEnterLv2: handelEnterLv2,
                                            handelLeaveLv2: handelLeaveLv2,
                                            taggingClick: taggingClick
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventNavi, {
                                        children: subMenuList && subMenuList.filter(function(o) {
                                            return o.dspSid === hoverLv1 && o.subDspTypeCd === "SUB";
                                        }).map(function(sub, subIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                    href: sub.dspUrl || "#",
                                                    target: (0,commonUtil/* getTarget */.U9)(sub.webMenuTarget),
                                                    children: sub.subDspNm
                                                })
                                            }, subIndex);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
var GNB = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "GNB Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GNBComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var Desktop_Gnb = (GNB);

;// CONCATENATED MODULE: ./framework/ui/desktop/header/NewHeader.tsx

function NewHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	a {\n		position: absolute;\n		display: block;\n		width: 1px;\n		height: 1px;\n		margin-bottom: -1px;\n		left: 0;\n		top: 0;\n		z-index: 100;\n		font-size: 14px;\n		font-weight: bold;\n		color: #fff;\n		text-align: center;\n		overflow: hidden;\n	}\n\n	&:focus {\n		width: 100%;\n		height: auto;\n		padding: 5px 0;\n		background: #333;\n	}\n"
    ]);
    NewHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	letter-spacing: -0.02em;\n\n	button {\n		cursor: pointer;\n		overflow: visible;\n		border: 0 none;\n		background-color: transparent;\n		font-family: "PT-medium", Sans-serif;\n		font-weight: normal;\n		font-size: 15px;\n		color: #555;\n		text-indent: 0;\n	}\n	h1 a {\n		display: block;\n	}\n	h1 a img {\n		width: 165px;\n		height: 44px;\n		vertical-align: top;\n	}\n	nav {\n		position: static;\n	}\n'
    ]);
    NewHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	height: 70px;\n	z-index: 11;\n\n	a {\n		display: block;\n		height: 100%;\n	}\n\n	div {\n		position: relative;\n		width: 1200px;\n		height: 70px;\n		margin: 0 auto;\n	}\n\n	img {\n		width: 100%;\n		height: 100%;\n		vertical-align: top;\n	}\n"
    ]);
    NewHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NewHeader_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 0;\n	top: 50%;\n	width: 25px;\n	height: 25px;\n	padding: 0;\n	margin: 0;\n	border: 0;\n	background: none;\n	transform: translateY(-50%);\n\n	&:before,\n	&:after {\n		position: absolute;\n		right: -3px;\n		height: 1px;\n		width: 32px;\n		background: #000;\n		border-radius: 1px;\n		content: "";\n	}\n\n	&:before {\n		transform: rotate(45deg);\n	}\n\n	&:after {\n		transform: rotate(-45deg);\n	}\n'
    ]);
    NewHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NewHeader_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding-top: 30px;\n	background-color: #fff;\n	z-index: 10;\n"
    ]);
    NewHeader_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NewHeader_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	background-color: #fff;\n	box-sizing: border-box;\n\n	&::after {\n		position: absolute;\n		bottom: 0;\n		height: 1px;\n		width: 100%;\n		background-color: #222;\n		content: "";\n	}\n'
    ]);
    NewHeader_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NewHeader_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 0 auto;\n"
    ]);
    NewHeader_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NewHeader_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	padding: 20px 0 10px;\n\n	> div:first-child {\n		display: flex;\n		gap: 30px;\n		align-items: center;\n	}\n\n	h1 {\n		line-height: 1;\n	}\n"
    ]);
    NewHeader_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NewHeader_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	gap: 40px;\n	align-items: center;\n\n	ul {\n		display: flex;\n	}\n	li {\n		position: relative;\n		padding-right: 13px;\n		margin-right: 10px;\n\n		&:after {\n			position: absolute;\n			right: 0;\n			top: 50%;\n			display: inline-block;\n			width: 3px;\n			height: 3px;\n			background-color: #ccc;\n			transform: translateY(-50%);\n			content: "";\n		}\n\n		&:last-child {\n			padding-right: 0;\n			margin-right: 0;\n		}\n\n		&:last-child::after {\n			display: none;\n		}\n	}\n	a {\n		color: #111;\n		font-size: 17px;\n	}\n'
    ]);
    NewHeader_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NewHeader_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 10px;\n\n	a {\n		box-sizing: border-box;\n	}\n"
    ]);
    NewHeader_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NewHeader_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 36px;\n	height: 36px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_mypage.png) center / cover no-repeat;\n"
    ]);
    NewHeader_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NewHeader_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-left: -15px;\n\n	> ul {\n		position: relative;\n		z-index: 1;\n		display: flex;\n	}\n"
    ]);
    NewHeader_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NewHeader_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    NewHeader_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NewHeader_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: block;\n	padding: 20px 15px;\n	font-family: "PT-regular";\n	font-size: 17px;\n	color: #555;\n	line-height: 1;\n\n	',
        "\n\n	&:hover {\n		color: #222;\n		font-weight: bold;\n	}\n"
    ]);
    NewHeader_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NewHeader_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: -2px;\n	left: 50%;\n	height: 16px;\n	width: 40px;\n	border-radius: 13px;\n	background-color: #ff5c46;\n	color: #fff;\n	font-size: 11px;\n	text-align: center;\n	font-family: "PT-bold";\n	line-height: 1.6;\n	transform: translateX(-50%);\n\n	&:after {\n		position: absolute;\n		bottom: -3px;\n		left: 50%;\n		transform: translateX(-50%);\n		width: 0px;\n		height: 0px;\n		border-top: 4px solid #ff5c46;\n		border-left: 4px solid transparent;\n		border-right: 4px solid transparent;\n		content: "";\n	}\n'
    ]);
    NewHeader_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NewHeader_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 163px;\n	left: 0;\n	width: 100%;\n	height: 50px;\n	background-color: #fff;\n	border-bottom: 1px solid #ddd;\n	box-sizing: border-box;\n"
    ]);
    NewHeader_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NewHeader_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	align-items: center;\n	width: 1200px;\n	margin: 0 auto;\n\n	> ul {\n		display: flex;\n	}\n"
    ]);
    NewHeader_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NewHeader_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	bottom: 0;\n	display: none;\n	width: 100%;\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	z-index: -1;\n"
    ]);
    NewHeader_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function NewHeader_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	left: 0;\n	top: 50px;\n	opacity: 0;\n	width: 100%;\n	min-height: 450px;\n	height: 450px;\n	background-color: #fff;\n	transform: scaleX(0) scaleY(0);\n	z-index: 10;\n"
    ]);
    NewHeader_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function NewHeader_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding-left: 20px;\n\n	&:first-child {\n		padding-left: 0;\n	}\n\n	> a {\n		position: relative;\n		display: flex;\n		align-items: center;\n		height: 50px;\n		font-size: 15px;\n		color: #555;\n		cursor: pointer;\n\n		&:hover {\n			font-weight: bold;\n			color: #222;\n\n			&:after {\n				position: absolute;\n				bottom: 1px;\n				left: 50%;\n				transform: translateX(-50%);\n				display: block;\n				width: 100%;\n				height: 2px;\n				background-color: #222;\n				height: 2px;\n				content: "";\n			}\n		}\n\n		~ ',
        ":focus-within {\n			opacity: 1;\n			transform: scaleX(1) scaleY(1);\n		}\n	}\n\n	&:hover ",
        " {\n		opacity: 1;\n		transform: scaleX(1) scaleY(1);\n	}\n\n	&:hover ",
        " {\n		display: block;\n	}\n\n	",
        ":hover {\n		display: none;\n	}\n\n	",
        "\n"
    ]);
    NewHeader_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function NewHeader_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 15px;\n	font-size: 14px;\n	color: #777;\n\n	li:hover {\n		color: #4567ad;\n	}\n"
    ]);
    NewHeader_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function NewHeader_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    NewHeader_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function NewHeader_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: block;\n	font-family: "PT-medium";\n	font-size: 18px;\n	color: #4567ad;\n\n	a {\n		margin-left: 7px;\n		color: #111;\n	}\n'
    ]);
    NewHeader_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function NewHeader_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding: 30px;\n	flex-basis: 300px;\n	box-sizing: border-box;\n\n	&:first-child {\n		flex-grow: 1;\n		background-color: #f5f5f5;\n	}\n\n	&:first-child:after {\n		display: none;\n	}\n\n	&:after {\n		position: absolute;\n		right: 0;\n		top: 0;\n		width: 1px;\n		height: 100%;\n		background-color: #ddd;\n		content: "";\n	}\n\n	ul {\n		display: flex;\n		flex-direction: column;\n		gap: 20px;\n		flex-wrap: wrap;\n		height: 340px;\n		width: 100%;\n		margin-top: 20px;\n	}\n\n	li {\n		width: 240px;\n		line-height: 1;\n	}\n'
    ]);
    NewHeader_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function NewHeader_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	li a {\n		display: block;\n		width: 100%;\n		align-items: center;\n		font-size: 15px;\n		color: #555;\n		text-overflow: ellipsis;\n		white-space: nowrap;\n		-o-text-overflow: ellipsis;\n		overflow: hidden;\n\n		&:hover {\n			color: #111;\n			text-decoration: underline;\n		}\n	}\n"
    ]);
    NewHeader_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function NewHeader_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	width: 340px;\n	height: 46px;\n	padding: 0 25px 0 20px;\n	border-radius: 30px;\n	border: 2px solid #ffcb31;\n	box-sizing: border-box;\n\n	a {\n		display: block;\n		width: 100%;\n		padding: 12px 0;\n		color: #999;\n		font-size: 15px;\n		",
        "\n	}\n"
    ]);
    NewHeader_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function NewHeader_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 23px;\n	height: 22px;\n	flex-shrink: 0;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/btn_search.png) no-repeat;\n	z-index: 1;\n"
    ]);
    NewHeader_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function NewHeader_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	width: 100%;\n	height: 30px;\n	background-color: #f3f3f3;\n	box-sizing: border-box;\n	font-size: 13px;\n	color: #555;\n\n	ul {\n		display: flex;\n		gap: 20px;\n		align-items: center;\n		justify-content: end;\n	}\n\n	li:hover {\n		color: #222;\n	}\n\n	a {\n		line-height: 30px;\n	}\n"
    ]);
    NewHeader_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function NewHeader_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    NewHeader_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function NewHeader_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-right: 12px;\n	color: #111;\n	cursor: pointer;\n\n	&:after {\n		content: "";\n		position: absolute;\n		top: 50%;\n		right: 0;\n		border-top: 4px solid #222;\n		border-left: 3px solid transparent;\n		border-right: 3px solid transparent;\n		transform: translateY(-50%);\n	}\n\n	',
        "\n"
    ]);
    NewHeader_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 25px;\n	right: -20px;\n	z-index: 1;\n	display: flex;\n	flex-direction: column;\n	gap: 12px;\n	width: 110px;\n	padding: 15px 15px 20px;\n	border: 1px solid #222;\n	border-radius: 3px;\n	background-color: #fff;\n	font-size: 13px;\n	color: #555;\n	box-sizing: border-box;\n\n	&:before {\n		content: "";\n		position: absolute;\n		top: -8px;\n		right: 50%;\n		width: 7px;\n		height: 7px;\n		background: #fff;\n		border-right: 1px solid #222;\n		border-bottom: 1px solid #222;\n		transform: rotate(-135deg) translateX(-50%);\n	}\n\n	a {\n		display: block;\n		line-height: 1;\n\n		&:hover {\n			color: #4567ad;\n			text-decoration: underline;\n		}\n	}\n'
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}





var NewHeader_SkipNavi = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-0"
})(NewHeader_templateObject());
var NewHeader_HeaderWrap = styled_components_browser_esm["default"].header.withConfig({
    componentId: "sc-938798ea-1"
})(NewHeader_templateObject1());
var NewHeader_TopBanner = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-2"
})(NewHeader_templateObject2());
var NewHeader_BtnBannerClose = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-938798ea-3"
})(NewHeader_templateObject3());
var NewHeader_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-4"
})(NewHeader_templateObject4());
var NewHeader_Gnb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-5"
})(NewHeader_templateObject5());
var GnbWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-6"
})(NewHeader_templateObject6());
var NewHeader_TopNavWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-7"
})(NewHeader_templateObject7());
var NewHeader_UtileLinks = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-8"
})(NewHeader_templateObject8());
var NewHeader_BtnGroup = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-9"
})(NewHeader_templateObject9());
var NewHeader_BtnMypage = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-938798ea-10"
})(NewHeader_templateObject10());
var NewHeader_Navi = styled_components_browser_esm["default"].nav.withConfig({
    componentId: "sc-938798ea-11"
})(NewHeader_templateObject11());
var NewHeader_BtnRecent = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-938798ea-12"
})(NewHeader_templateObject12(), function(props) {
    return props.$hasRecent ? "width: 34px;\n				height: 34px;\n				border: 1px solid #bbb;\n				border-radius: 8px;\n				overflow: hidden;\n\n				img {\n					width: 100%;\n					height: 100%;\n				}\n				" : "\n				width: 36px;\n				height: 36px;\n				border: none;\n				background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_recent.png) center / cover no-repeat;\n			";
});
var NewHeader_GnbItem = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-938798ea-13"
})(NewHeader_templateObject13(), function(props) {
    return props.$isActive && "\n			color: #222;\n			font-weight:bold;\n	";
});
var NewHeader_IconBadge = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-938798ea-14"
})(NewHeader_templateObject14());
var NewHeader_Lnb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-15"
})(NewHeader_templateObject15());
var NewHeader_LnbWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-16"
})(NewHeader_templateObject16());
var NewHeader_Dim = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-17"
})(NewHeader_templateObject17());
var NewHeader_Category = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-18"
})(NewHeader_templateObject18());
var NewHeader_LnbItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-938798ea-19"
})(NewHeader_templateObject19(), NewHeader_Category, NewHeader_Category, NewHeader_Dim, NewHeader_Dim, function(props) {
    return props.$isActive && '\n	> a {\n		font-weight: bold;\n		color: #222;\n\n		&:after {\n			position: absolute;\n			bottom: 1px;\n			left: 50%;\n			transform: translateX(-50%);\n			display: block;\n			width: 100%;\n			height: 2px;\n			background-color: #222;\n			height: 2px;\n			content: "";\n			}\n		}\n\n	';
});
var NewHeader_EventNavi = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-938798ea-20"
})(NewHeader_templateObject20());
var NewHeader_CategoryWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-21"
})(NewHeader_templateObject21());
var NewHeader_CategorySubtitle = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-938798ea-22"
})(NewHeader_templateObject22());
var NewHeader_CategoryArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-23"
})(NewHeader_templateObject23());
var NewHeader_List = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-938798ea-24"
})(NewHeader_templateObject24());
var NewHeader_SearchWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-25"
})(NewHeader_templateObject25(), (0,desktop_text/* Ellipsis */.mH)(1));
var NewHeader_BtnSearch = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-938798ea-26"
})(NewHeader_templateObject26());
var NewHeader_GnbUtil = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-27"
})(NewHeader_templateObject27());
var NewHeader_GnbUtilWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-28"
})(NewHeader_templateObject28());
var NewHeader_Login = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-938798ea-29"
})(NewHeader_templateObject29(), function(props) {
    return props.$isShow && "\n		&:after {\n			border-top: 0;\n			border-bottom: 4px solid #222;\n		}\n	";
});
var NewHeader_LoginTooltip = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-938798ea-30"
})(_templateObject30());
var NewHeader_Header = function() {
    var ref = useState(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var tooltipRef = useRef(null);
    var ref1 = useState(false), isHovered = ref1[0], setIsHovered = ref1[1];
    var loginRef = useRef(null);
    // 로그인시 나오는 툴팁
    var handleClickOutside = function(event) {
        var ref, ref1;
        var target = event.target;
        if (target && !((ref = tooltipRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) && !((ref1 = loginRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) {
            setShowTooltip(false);
        }
    };
    useEffect(function() {
        if (showTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showTooltip
    ]);
    var handleClick = function() {
        setShowTooltip(function(prev) {
            return !prev;
        });
    };
    // 1 Depth hover시 2 Depth 보여주기
    var handleMouseEnter = function() {
        return setIsHovered(true);
    };
    var handleMouseLeave = function() {
        return setIsHovered(false);
    };
    return /*#__PURE__*/ _jsxs(NewHeader_HeaderWrap, {
        children: [
            /*#__PURE__*/ _jsx(NewHeader_TopBanner, {
                style: {
                    backgroundColor: "#fdebe9"
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: "#",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner.jpg",
                                alt: "배너 이미지"
                            })
                        }),
                        /*#__PURE__*/ _jsx(NewHeader_BtnBannerClose, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "배너 닫기"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(NewHeader_Container, {
                children: [
                    /*#__PURE__*/ _jsxs(NewHeader_SkipNavi, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "#content",
                                children: "본문 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb",
                                children: "카테고리 메뉴 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb-login",
                                children: "로그인 메뉴 바로가기"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(NewHeader_Gnb, {
                        children: [
                            /*#__PURE__*/ _jsxs(GnbWrap, {
                                id: "gnb",
                                children: [
                                    /*#__PURE__*/ _jsxs(NewHeader_TopNavWrap, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h1", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "/index.yb",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "https://cimgcdn.ybtour.co.kr/common/logo/logo_l.png",
                                                                alt: "노랑풍선"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(NewHeader_SearchWrap, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "검색 프로모션 영역 텍스트"
                                                            }),
                                                            /*#__PURE__*/ _jsx(NewHeader_BtnSearch, {
                                                                type: "button",
                                                                onClick: function() {
                                                                    location.href = "https://pkg.ybtour.co.kr/common/searchGoods.yb";
                                                                },
                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                    children: "검색"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(NewHeader_UtileLinks, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("ul", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "베스트"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "마감임박"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "출발보장"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "썸머특가"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "당장노랑"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(NewHeader_BtnGroup, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(NewHeader_BtnMypage, {
                                                                href: "https://pkg.ybtour.co.kr/mypage/index.yb",
                                                                children: /*#__PURE__*/ _jsx(Accessibility, {
                                                                    children: "마이페이지"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs(NewHeader_BtnRecent, {
                                                                href: "#",
                                                                $hasRecent: true,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Accessibility, {
                                                                        children: "최근본"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Noimage, {
                                                                        width: "32px",
                                                                        height: "32px",
                                                                        src: "https://dimgcdn.ybtour.co.kr/TN/99/99897c62991b42e78a3c3fad024dce69.tn.410x280.jpg",
                                                                        alt: "상품 이미지"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(NewHeader_Navi, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("ul", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            $isActive: isHovered,
                                                            onMouseEnter: handleMouseEnter,
                                                            onMouseLeave: handleMouseLeave,
                                                            children: "해외패키지"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "에어텔"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsxs(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(NewHeader_IconBadge, {
                                                                    children: "NEW"
                                                                }),
                                                                "허니문"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsxs(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(NewHeader_IconBadge, {
                                                                    children: "HOT"
                                                                }),
                                                                "골프"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "크루즈"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "프리미엄"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "국내여행"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "항공"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "호텔"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "투어&티켓"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "렌터카"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "기업/단체"
                                                        })
                                                    })
                                                ]
                                            }),
                                            isHovered && /*#__PURE__*/ _jsx(NewHeader_Lnb, {
                                                onMouseEnter: handleMouseEnter,
                                                onMouseLeave: handleMouseLeave,
                                                children: /*#__PURE__*/ _jsxs(NewHeader_LnbWrap, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("ul", {
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    $isActive: isHovered,
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "유럽"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 유럽"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_6"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_7"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_8"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_9"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "테마별"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "6"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "프로모션"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가 프로모션 프로모션 프로모션 프로모션"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "아시아나 항공 유럽 SUMMER 특가"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "유럽의 숨겨진 보물, HENANN RESORT"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "상상 이상의 행복한 허니문을 위한 Fourseasons in France"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "동남아"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역별",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 동남아"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_6"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_7"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_8"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_9"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_10"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_11"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_12"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_13"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_14"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_15"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_16"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_17"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_18"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "테마별"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "6"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "프로모션"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "창립 21주년 기념, 동남아 5만원 할인!"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "격리없이 떠나는 푸켓"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "샹그릴라&요트선셋투어 in 싱가포르"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "동남아! 할인챌린지 앙코르전"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "아시아나 A380 타고 떠나는 방콕/파타야"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "일본"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역별",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 일본"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(NewHeader_CategoryArea, {}),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "프로모션"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "오사카 여행 200% 즐기는 방법"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "나만 알고싶은 소도시로, 단풍여행"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "겨울시즌 온천여행 오이타"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "황금연휴 출발확정"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "MZ 취향저격 특급호텔 호캉스 MZ 취향저격 특급호텔 호캉스"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "괌/사이판"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역별",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 괌/사이판"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "테마별"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(NewHeader_List, {
                                                                                                children: /*#__PURE__*/ _jsx("li", {
                                                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "여행에 테마를 더하다"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(NewHeader_CategoryArea, {})
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "호주/뉴질랜드"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "미주/캐나다/하와이"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "중남미/아프리카"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "대만/홍콩/마카오"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "중국/몽골/중아아시아"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "부산/지방 출발"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(NewHeader_EventNavi, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("li", {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "기획전"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("li", {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "이벤트"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("li", {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "홈쇼핑"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(NewHeader_GnbUtil, {
                                id: "gnb-login",
                                children: /*#__PURE__*/ _jsx(NewHeader_GnbUtilWrap, {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsxs(NewHeader_Login, {
                                                onClick: handleClick,
                                                $isShow: showTooltip,
                                                ref: loginRef,
                                                children: [
                                                    "김노랑 님",
                                                    showTooltip && /*#__PURE__*/ _jsxs(NewHeader_LoginTooltip, {
                                                        ref: tooltipRef,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "개인정보 수정"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "비밀번호 변경"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "SNS 연결 설정"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "#",
                                                    children: "로그아웃"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/mypage/resvInfo.yb",
                                                    children: "예약확인/결제"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                                    children: "고객센터"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

/* harmony default export */ var NewHeader = ((/* unused pure expression or super */ null && (NewHeader_Header)));

// EXTERNAL MODULE: ./framework/utils/logger.ts
var logger = __webpack_require__(42277);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
;// CONCATENATED MODULE: ./hooks/services/queries/bff/global/useGlobalBannerText.ts




/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/bannerTextList`
 * parameter
 * 		bnrType: KEYWORD (공통코드: TXT_BNR_TYPE)
 *      keyword: string
 * ```*/ var key = "useGlobalBannerText";
var getPath = function() {
    return "".concat("https://support.ybtour.co.kr", "/api/bff/link/global/bannerTextList");
};
/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/bannerTextList`
 * parameter
 * 		bnrType: KEYWORD (공통코드: TXT_BNR_TYPE)
 *      keyword: string
 * ```*/ var useGlobalBannerText = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        bnrType: "KEYWORD",
        keyword: ""
    }, options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,useQuery/* useQuery */.a)((0,_object_spread/* default */.Z)({
            queryKey: [
                key,
                getPath()
            ],
            queryFn: function() {
                return (0,useConfigureAxios/* default */.Z)({
                    url: getPath(),
                    params: params
                }).then(function(r) {
                    return r.data;
                });
            },
            throwOnError: false
        }, options));
    } catch (error) {
        logger/* default.error */.Z.error(error);
    }
};
/* harmony default export */ var global_useGlobalBannerText = (useGlobalBannerText);


;// CONCATENATED MODULE: ./components/layout/header/Desktop/SearchArea.tsx








/**
 * 헤더 검색 영역
 */ var SearchArea = function() {
    var ref;
    var globalBannerTextFetch = global_useGlobalBannerText();
    var globalBannerText = ((ref = globalBannerTextFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var filteredBannerText = (0,react.useMemo)(function() {
        return globalBannerText.filter(function(o) {
            return o.pcYn === "Y";
        });
    }, [
        globalBannerText
    ]);
    var ref1 = (0,react.useState)(null), bannerText = ref1[0], setBannerText = ref1[1];
    (0,react.useEffect)(function() {
        if (filteredBannerText.length > 0) {
            setBannerText(filteredBannerText[Math.floor(Math.random() * filteredBannerText.length)]);
        }
    }, [
        filteredBannerText
    ]);
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_search_keyword", bannerText).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewHeader_SearchWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/searchGoods.yb"),
                children: (bannerText === null || bannerText === void 0 ? void 0 : bannerText.keyword) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_BtnSearch, {
                type: "button",
                onClick: function(e) {
                    taggingClick();
                    var url = (bannerText === null || bannerText === void 0 ? void 0 : bannerText.pcUrl) || "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/searchGoods.yb");
                    (0,commonUtil/* onClickSSO */.Zy)(e, url);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "검색"
                })
            })
        ]
    });
};
/* harmony default export */ var Desktop_SearchArea = (SearchArea);

;// CONCATENATED MODULE: ./hooks/services/queries/bff/global/useGlobalOpt.ts




/** ```
 * 공통 운영 메뉴 조회 API
 *   `/global/opt/list`
 * ```*/ var useGlobalOpt_key = "useGlobalOpt";
var useGlobalOpt_getPath = function() {
    return "".concat("https://support.ybtour.co.kr", "/api/bff/link/global/optList");
};
/** ```
 * 공통 운영 메뉴 조회 API
 *   `/global/opt/list`
 * ```*/ var useGlobalOpt = function(options) {
    try {
        return (0,useQuery/* useQuery */.a)((0,_object_spread/* default */.Z)({
            queryKey: [
                useGlobalOpt_key,
                useGlobalOpt_getPath()
            ],
            queryFn: function() {
                return (0,useConfigureAxios/* default */.Z)({
                    url: useGlobalOpt_getPath()
                }).then(function(r) {
                    return r.data;
                });
            },
            throwOnError: false
        }, options));
    } catch (error) {
        logger/* default.error */.Z.error(error);
    }
};
/* harmony default export */ var global_useGlobalOpt = (useGlobalOpt);


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/layout/header/Desktop/index.tsx
















var HeaderComponent = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    /** 로그인 정보 */ var signin = (0,useCustomerMe/* default */.ZP)({
        throwOnError: false
    });
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
    var custNmKor = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.body.custNmKor) || "";
    var isSignin = ((ref2 = signin.data) === null || ref2 === void 0 ? void 0 : ref2.body.nonUser) === false;
    /** 최근 본 관련 */ var userId = (0,commonUtil/* getCookie */.ej)("userId") || (window.ensureUserHasUniqueId ? window.ensureUserHasUniqueId() : "");
    var recentlyListFetch = (0,useGetRecently/* default */.Z)(userId, webCustNo, {
        enabled: !signin.isFetching && !!userId,
        throwOnError: false
    });
    var recently = ((ref3 = recentlyListFetch.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.productResultList) === null || ref5 === void 0 ? void 0 : ref5.at(0)) || null;
    var ref7 = (0,react.useState)(false), recentlyOpen = ref7[0], setRecentlyOpen = ref7[1];
    var ref8 = (0,react.useState)(false), recentlyShow = ref8[0], setRecentlyShow = ref8[1];
    /** routing 시 최근 본 상품 닫기  */ var handleRouteChange = function() {
        setRecentlyShow(false);
        setRecentlyOpen(false);
    };
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    /** 운영 메뉴 관련 */ var globalOptFetch = global_useGlobalOpt();
    var globalOpt = (ref6 = globalOptFetch.data) === null || ref6 === void 0 ? void 0 : ref6.body;
    /** publish */ var ref9 = (0,react.useState)(false), showTooltip = ref9[0], setShowTooltip = ref9[1];
    var ref10 = (0,react.useState)(false), isDim = ref10[0], setIsisDim = ref10[1];
    var handleDim = function(is) {
        return setIsisDim(is);
    };
    var tooltipRef = (0,react.useRef)(null);
    var loginRef = (0,react.useRef)(null);
    // 로그인시 나오는 툴팁
    var handleClickOutside = function(event) {
        var ref, ref1;
        var target = event.target;
        if (target && !((ref = tooltipRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) && !((ref1 = loginRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) {
            setShowTooltip(false);
        }
    };
    (0,react.useEffect)(function() {
        if (showTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showTooltip
    ]);
    var handleClick = function() {
        setShowTooltip(function(prev) {
            return !prev;
        });
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_icon_main").taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_Recently, {
                open: recentlyOpen,
                show: recentlyShow,
                closeShow: function() {
                    return setRecentlyShow(false);
                },
                closeOpen: function() {
                    return setRecentlyOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkipNavi, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#content",
                                        children: "본문 바로가기"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#gnb",
                                        children: "카테고리 메뉴 바로가기"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#gnb-login",
                                        children: "로그인 메뉴 바로가기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gnb, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopNavWrap, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "https://cimgcdn.ybtour.co.kr/common/logo/logo_ev.png",
                                                                alt: "노랑풍선"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SearchArea, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UtileLinks, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: globalOpt && globalOpt.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                                    href: item.pcMenuUrl,
                                                                    target: (0,commonUtil/* getTarget */.U9)(item.webMenuTarget),
                                                                    onClick: function() {
                                                                        return taggingClick(item);
                                                                    },
                                                                    children: item.pcMenuNm
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnGroup, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnMypage, {
                                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/index.yb"),
                                                                onClick: function(e) {
                                                                    var url = "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/index.yb");
                                                                    (0,commonUtil/* onClickSSO */.Zy)(e, url);
                                                                    if (!isSignin) LoginUtil.login(url);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* Accessibility */.yq, {
                                                                    children: "마이페이지"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnRecent, {
                                                                href: "#",
                                                                $hasRecent: !!recently,
                                                                onClick: function() {
                                                                    setRecentlyOpen(true);
                                                                    setRecentlyShow(true);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* Accessibility */.yq, {
                                                                        children: "최근본"
                                                                    }),
                                                                    (recently === null || recently === void 0 ? void 0 : recently.imgUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: recently.imgUrl,
                                                                        alt: "상품 이미지"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_Gnb, {
                                        handleDim: handleDim
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GnbUtil, {
                                        id: "gnb-login",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GnbUtilWrap, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    isSignin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login, {
                                                                onClick: handleClick,
                                                                $isShow: showTooltip,
                                                                ref: loginRef,
                                                                children: [
                                                                    custNmKor,
                                                                    " 님",
                                                                    showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginTooltip, {
                                                                        ref: tooltipRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                                                href: "".concat(config_public/* default.ENV_ACCOUNTS_DOMAIN */.Z.ENV_ACCOUNTS_DOMAIN, "/settings/profile"),
                                                                                children: "개인정보 수정"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                                                href: "".concat(config_public/* default.ENV_ACCOUNTS_DOMAIN */.Z.ENV_ACCOUNTS_DOMAIN, "/settings/password"),
                                                                                children: "비밀번호 변경"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                                                href: "".concat(config_public/* default.ENV_ACCOUNTS_DOMAIN */.Z.ENV_ACCOUNTS_DOMAIN, "/settings/social"),
                                                                                children: "SNS 연결 설정"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "#",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        LoginUtil.logout();
                                                                    },
                                                                    children: "로그아웃"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "#",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        LoginUtil.login();
                                                                    },
                                                                    children: "로그인"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                                    href: "".concat(config_public/* default.ENV_ACCOUNTS_DOMAIN */.Z.ENV_ACCOUNTS_DOMAIN, "/signUp"),
                                                                    children: "회원가입"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/resvInfo.yb"),
                                                            children: "예약확인/결제"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/main.yb"),
                                                            children: "고객센터"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isDim && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dim, {})
                ]
            })
        ]
    });
};
var Desktop_Header = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Header Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderComponent, {})
    });
};
/* harmony default export */ var Desktop = (Desktop_Header);


/***/ }),

/***/ 89071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EventListPopup_EventListPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/flag/Desktop.tsx
var Desktop = __webpack_require__(76031);
// EXTERNAL MODULE: ./components/common/modal/share/Desktop.tsx + 3 modules
var share_Desktop = __webpack_require__(90451);
// EXTERNAL MODULE: ./components/product/common/popup/common/constant.ts
var constant = __webpack_require__(6243);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./components/style/productlist/departurepopup.tsx
var departurepopup = __webpack_require__(89371);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(38502);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 3 modules
var layout = __webpack_require__(47178);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventList.tsx










var EventList = function(props) {
    var ref;
    var _data = props.data, data = _data === void 0 ? [] : _data, sort = props.sort, filters = props.filters, setFilters = props.setFilters, currentDate = props.currentDate;
    var eventList = (0,react.useMemo)(function() {
        var filterList = (0,_to_consumable_array/* default */.Z)(data);
        var prop = sort.prop, asc = sort.asc;
        if (currentDate) filterList = filterList.filter(function(v) {
            return v.outStartDt === currentDate;
        });
        /** 정렬 */ filterList = filterList.sort(function(a, b) {
            if (asc) {
                // eslint-disable-next-line no-nested-ternary
                return Number(a[prop]) > Number(b[prop]) ? 1 : Number(a[prop]) < Number(b[prop]) ? -1 : 0;
            } else {
                // eslint-disable-next-line no-nested-ternary
                return Number(b[prop]) > Number(a[prop]) ? 1 : Number(b[prop]) < Number(a[prop]) ? -1 : 0;
            }
        });
        return filterList;
    }, [
        data,
        sort,
        currentDate
    ]);
    // 예약 마감된 상품도 함께 보기
    var handleFilterReserve = function() {
        var copyArray = filters.filter(function(v) {
            return v.key !== "isEvReserve";
        });
        setFilters(copyArray);
    };
    // 예약가능 여부
    var isReserve = ((ref = filters.find(function(v) {
        return v.key === "isEvReserve";
    })) === null || ref === void 0 ? void 0 : ref.value) === "true";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionList */.Dq, {
        children: [
            eventList.length > 0 && eventList.map(function(item, index) {
                var trTp = item.trTp, trCompanyNm = item.trCompanyNm, outDeprtTm = item.outDeprtTm, inArrvTm = item.inArrvTm, evReserveStatus = item.evReserveStatus, goodsTp = item.goodsTp, seatClassCd = item.seatClassCd, seatClassNm = item.seatClassNm;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
                        href: item.weblinkurl || "#",
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionDate */.q, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "".concat((0,eventUtil/* departureStart */.jn)({
                                                    evStartDt: item.outStartDt,
                                                    outDeprtTm: outDeprtTm
                                                }), " - ").concat((0,eventUtil/* returnArrival */.jp)({
                                                    evArriveDt: item.inArriveDt,
                                                    inArrvTm: inArrvTm
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: item.dayStayInfo.replace(/^(\d)박(\d)일$/, "$1박 $2일")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                        gap: "6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagEmpasisCd */.k0, {
                                                emphasisCd: item.emphasisCd
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagEvProgDivi */.X, {
                                                evProgDivi: item.evProgDivi,
                                                evProgDiviNm: item.evProgDiviNm
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PromotionTitle */.GU, {
                                children: item.evNm
                            }),
                            item.accomNm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionOption */.Mo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "옵션"
                                    }),
                                    item.accomNm
                                ]
                            }),
                            item.couponYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* CouponBox */.ql, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "쿠폰"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CouponIcon */.zc, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: item.couponOptTy === "M" ? ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.couponDiscAmt) : "".concat(item.couponDiscRate, "%")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionPrice */.S2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Flex */.kC, {
                                        grow: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                            img: (0,eventUtil/* getTrafficIconUrl */.wz)(item),
                                            title: trTp ? "".concat(trCompanyNm, " ").concat(seatClassCd && seatClassCd !== "EC" ? "(".concat(seatClassNm, ")") : "") : "교통불포함"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            [
                                                "F",
                                                "H"
                                            ].indexOf(item.goodsTp) === -1 && item.evProgDivi !== "05" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* SeatsAvailable */.xF, {
                                                children: [
                                                    "(잔여 ",
                                                    item.avlilBlockQty,
                                                    "석)"
                                                ]
                                            }),
                                            evReserveStatus === "end" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Status */.qb, {
                                                state: "deadline",
                                                children: "예약마감"
                                            }),
                                            evReserveStatus === "wait" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Status */.qb, {
                                                state: "waiting",
                                                children: "예약대기"
                                            }),
                                            evReserveStatus === "can" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Status */.qb, {
                                                state: "possible",
                                                children: [
                                                    "F",
                                                    "H"
                                                ].indexOf(goodsTp) > -1 ? "예약접수가능" : "예약가능"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* Price */.tA, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.sumPrice)
                                                    }),
                                                    "원~"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, index);
            }),
            !eventList || eventList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* EmptyBox */.cs, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: isReserve ? "해당 조건으로 예약가능한 상품이 없습니다." : "해당 조건의 상품이 없습니다."
                        }),
                        isReserve && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: handleFilterReserve,
                            children: "예약 마감된 상품도 함께 보기"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var EventListPopup_EventList = (EventList);

// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./hooks/common/useCountdown.tsx
var useCountdown = __webpack_require__(71392);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./public/P/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(39044);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./public/P/images/content/event/yellowpick/banner_yellowpick_1200.png
var banner_yellowpick_1200 = __webpack_require__(4866);
var banner_yellowpick_1200_default = /*#__PURE__*/__webpack_require__.n(banner_yellowpick_1200);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListBanner.tsx












var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var BannerContents = function(param) {
    var contents = param.contents;
    // 이미지 없을 경우 구름 이미지 표시
    var imageOnError = function(e) {
        e.currentTarget.src = (ico_nodata_default());
        e.currentTarget.className = "img-error";
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_calender", {
        selectDiv: "calenderMidBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* EventBanner */.cK, {
        children: contents && contents.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link),
                target: (0,commonUtil/* getTarget */.U9)(item.target),
                onClick: function() {
                    return taggingClick(item);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.imgPath),
                    alt: item.alt,
                    onError: imageOnError
                })
            }, index);
        })
    });
};
var BannerYellowLive = function(param) {
    var live = param.live;
    dayjs_min_default().extend((isBetween_default())); // isBetween 사용
    var dspYn = live.dspYn, liveDt = live.liveDt, liveTime = live.liveTime;
    // 방송 노출 조건 Y가 아닌 경우 - 노출 X
    if (dspYn !== "Y") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var liveStartDate = dayjs_min_default()(liveDt);
    var liveEndDate = liveStartDate.add(Number(liveTime), "minute");
    var today = dayjs_min_default()();
    var LiveText = function() {
        if (today.isBefore(liveStartDate)) {
            var countdown = (0,useCountdown/* default */.Z)(liveStartDate);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveDate */.Uq, {
                        children: "COMING SOON"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveState */.I7, {
                        children: countdown
                    })
                ]
            });
        } else if (today.isBetween(liveStartDate, liveEndDate)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveDate */.Uq, {
                        children: "ON AIR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveState */.I7, {
                        children: "실시간 방송 중"
                    })
                ]
            });
        } else {
            var formattedDate = "".concat(liveStartDate.format("MM/DD"), "(").concat(daykor[liveStartDate.day()], ") ").concat(liveStartDate.format("HH:mm"));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveDate */.Uq, {
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveState */.I7, {
                        children: "방영 완료"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* BannerYellowLive */.$g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
            href: "".concat(config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL, "/promotion/yellowLive"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* LiveText */.sS, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveTit */.TH, {
                            children: "최대 혜택으로 떠나는 생생한 여행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveText, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveLink */.Ge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "바로가기"
                    })
                })
            ]
        })
    });
};
var BannerYellowPangDeal = function(param) {
    var deal = param.deal;
    var PangdealText = function() {
        var targetDate = dayjs_min_default()(deal.dealEdTm).add(1, "minute");
        var countdown = (0,useCountdown/* default */.Z)(targetDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PangdealText */.Kr, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealProduct */.pb, {
                            children: deal.dealType === "T" ? "타임특가" : "선착순특가"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealDate */.Q0, {
                            children: deal.dealType === "T" ? countdown !== null && countdown !== void 0 ? countdown : "종료" : "상품 ".concat(deal.dealRervCnt || 0, "개")
                        }),
                        countdown !== null && " 남음"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "".concat(deal.dealRervCnt > 0 || countdown !== null ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(deal.price - deal.dealGoodsPrice), "원 즉시할인가격") : "")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* BannerYellowpangdeal */.yn, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
            target: "_self",
            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/promotion/yellowPangDeal.yb"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealPrice */.G_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PangdealText, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealLink */.rV, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "전체보기"
                    })
                })
            ]
        })
    });
};
var BannerYellowPick = function(param) {
    var pick = param.pick;
    var link = pick.webBannerLink === "AUTOLINK" ? "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/promotion/promotionDetail.yb?mstNo=").concat(pick.bnrMstNo) : pick.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* EventBanner */.cK, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (banner_yellowpick_1200_default()),
                alt: "옐로PICK 혜택 특가로 떠나는 이달의 여행지"
            })
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./framework/ui/desktop/select/index.ts
var desktop_select = __webpack_require__(64249);
// EXTERNAL MODULE: ./components/hoc/withCalendar.tsx
var withCalendar = __webpack_require__(25893);
// EXTERNAL MODULE: ./hooks/services/queries/essential/contents/useContentsHoliday.ts
var useContentsHoliday = __webpack_require__(6843);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListCalendar.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 400px;\n	background-color: #fff;\n\n	table {\n		th {\n			height: 44px;\n			background-color: #fff;\n			text-align: center;\n			border-top: none;\n		}\n		td {\n			height: 77px;\n			padding: 0;\n			border: 1px solid var(--line-color);\n			&:not(:last-child) {\n				border-right-color: #eee;\n			}\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	border-top: 1px solid var(--line-color);\n	border-right: 1px solid var(--line-color);\n	border-left: 1px solid var(--line-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	width: 177px;\n	height: 70px;\n	margin: 0 auto;\n	justify-content: center;\n\n	em {\n		font-size: 22px;\n		font-weight: bold;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n	label {\n		font-size: var(--medium-size);\n		font-weight: normal;\n	}\n	ul {\n		top: 50px;\n		left: 50%;\n		width: 245px;\n		max-height: 155px;\n		transform: translateX(-50%);\n		> li {\n			justify-content: center;\n			padding: 0;\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 32px;\n	width: 9px;\n	height: 9px;\n	border-left: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--emp-color);\n	background-color: transparent;\n\n	&:disabled {\n		border-color: var(--bl-color);\n	}\n\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	table-layout: fixed;\n\n	th {\n		&:first-child {\n			border-left: 1px solid var(--line-color);\n		}\n\n		&:last-child {\n			border-right: 1px solid var(--line-color);\n		}\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 35px;\n	padding: 10px;\n	box-sizing: border-box;\n	border-top: 1px solid var(--line-color);\n	color: var(--emp-color);\n	text-align: center;\n	&:first-child {\n		color: #ff5c46;\n	}\n	&:last-child {\n		color: #4567ad;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	box-sizing: border-box;\n	height: 35px;\n	color: #aaa;\n	vertical-align: top;\n	text-align: left;\n	cursor: initial;\n\n	> span {\n		border: 1px solid transparent;\n		outline: 1px solid ",
        ";\n		font-size: var(--basic-size);\n		box-sizing: border-box;\n	}\n\n	&:first-child {\n		> span {\n			color: var(--red-color);\n		}\n	}\n	&:last-child {\n		> span {\n			color: var(--blue-color);\n		}\n	}\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	padding-top: 4px;\n	width: 100%;\n	height: 100%;\n	color: ",
        ";\n	align-items: start;\n	justify-content: center;\n	line-height: 1;\n	z-index: 2;\n\n	span {\n		display: flex;\n		width: 26px;\n		padding: 5px 0 7px;\n		align-items: center;\n		justify-content: center;\n		z-index: 2;\n	}\n	",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			color: #ff3e24;\n		"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	display: flex;\n	bottom: 0;\n	width: 100%;\n	height: 40px;\n	font-size: 13px;\n	color: var(--default-color);\n	align-items: center;\n	justify-content: center;\n\n	",
        "\n	",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	letter-spacing: 0;\n	label {\n		font-size: 22px;\n		font-family: "PT-medium";\n	}\n\n	&:before {\n		right: -15px;\n		top: 35px;\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}









var CalendarBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-894f546-0"
})(_templateObject());
var CalendarMonthWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-894f546-1"
})(_templateObject1());
var CalendarMonth = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-894f546-2"
})(_templateObject2());
var MonthButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-894f546-3"
})(_templateObject3(), function(props) {
    return props.types === "prev" ? "\n                left: 0px;\n                transform: rotate(45deg);\n            " : "\n                right: 0px;\n                transform: rotate(-135deg);\n            ";
});
var TableCalendar = styled_components_browser_esm["default"].table.withConfig({
    componentId: "sc-894f546-4"
})(_templateObject4());
var Month = styled_components_browser_esm["default"].th.withConfig({
    componentId: "sc-894f546-5"
})(_templateObject5());
var ProductDays = styled_components_browser_esm["default"].td.withConfig({
    componentId: "sc-894f546-6"
})(_templateObject6(), function(props) {
    return props.CheckedDay ? "var(--emp-color)" : "transparent";
}, function(props) {
    return props.isActive && "\n        color: var(--emp-color);\n        cursor: pointer;\n\n        &:hover {\n            > span {\n                outline: 1px solid var(--emp-color);\n            }\n        }\n    ";
});
var Day = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-894f546-7"
})(_templateObject7(), function(props) {
    return props.holiday ? "var(--red-color)" : "";
}, function(props) {
    return props.today && "\n			span {\n				border-radius: 50%;\n				background-color: var(--emp-color);\n				color: #fff;\n			}\n		";
});
var ResStatus = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-894f546-8"
})(_templateObject9(), function(props) {
    if (props.state === "possible") {
        return "\n			background-color: var(--yellow-color);\n		  ";
    }
    if (props.state === "waiting") {
        return "\n			background-color: #bfd1f5;\n		  ";
    }
    if (props.state === "deadline") {
        return "\n			background-color: var(--line-color);\n		  ";
    }
}, function(props) {
    return props.lowestPrice && (0,styled_components_browser_esm.css)(_templateObject8());
});
var CalendarSelectBox = (0,styled_components_browser_esm["default"])(desktop_select/* SelectBox */.jL).withConfig({
    componentId: "sc-894f546-9"
})(_templateObject10());
var formatPrice = function(prop) {
    if (prop < 10000) {
        return "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(prop), "원~");
    }
    var million = Math.floor(prop / 10000);
    return "".concat(million, "만~");
};
var EventListCalendar = (0,withCalendar/* default */.Z)(function(props, ref) {
    var date = props.date, isNext = props.isNext, isPrevious = props.isPrevious, rangeMonth = props.rangeMonth, // dayList,
    month = props.month, // min,
    // max,
    data = props.data, // clearDate,
    dateChange = props.dateChange, monthChange = props.monthChange, nextMonth = props.nextMonth, prevMonth = props.prevMonth;
    var id = (0,react.useId)();
    var ref1 = (0,react.useState)(false), showMonth = ref1[0], setShowMonth = ref1[1];
    (0,react.useEffect)(function() {
        var event = function(e) {
            if (document.body.contains(e.target)) {
                !e.target.closest("#selectWrap-".concat(CSS.escape(id))) && setShowMonth(false);
                e.target.closest("#options-".concat(CSS.escape(id))) && setShowMonth(false);
            }
        };
        setTimeout(function() {
            return window.addEventListener("click", event);
        });
        return function() {
            window.removeEventListener("click", event);
        };
    }, []);
    var eventList = data === null || data === void 0 ? void 0 : data.eventList;
    var minPrice = data === null || data === void 0 ? void 0 : data.minPrice;
    var holidayFetch = (0,useContentsHoliday/* default */.ZP)(dayjs_min_default()(month).format("YYYY"), {
        staleTime: 1000 * 60 * 5
    });
    var today = dayjs_min_default()();
    var groupByEvStartDt = (0,react.useMemo)(function() {
        var result = {};
        if (!eventList) return result;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = eventList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var outStartDt = item.outStartDt;
                if (!result[outStartDt]) {
                    result[outStartDt] = [];
                }
                result[outStartDt].push(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }, [
        eventList,
        month
    ]);
    var makeEventDayList = (0,react.useCallback)(function(referenceDate) {
        var dayCount = referenceDate.date(1).daysInMonth();
        /** 1~7 월~일 */ var startWeekDay = referenceDate.day();
        var endWeekDay = referenceDate.date(dayCount).day();
        var firstWeekEmptyArray = Array(startWeekDay).fill(null);
        var lastWeekEmptyArray = Array(6 - endWeekDay).fill(null);
        var dayArray = Array(dayCount).fill(0).map(function(o, index) {
            var _Math;
            var ref, ref1, ref2, ref3;
            var result = {};
            var day = referenceDate.add(index, "day");
            var dayFormat = day.format("YYYYMMDD");
            /* 공휴일 */ var holiday = !!((ref = holidayFetch.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                return v.calDt === dayFormat;
            }));
            /* 최저가 */ var priceArray = ((ref2 = groupByEvStartDt[dayFormat]) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                return item.sumPrice;
            })) || [];
            var price = priceArray.length > 0 ? (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(priceArray)) : 0;
            /* can: 예약가능, wait: 예약대기, end: 예약마감 */ var calStatusArray = ((ref3 = groupByEvStartDt[dayFormat]) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                return item.evReserveStatus;
            })) || [];
            var resStatus = "";
            if (calStatusArray.includes("can")) {
                resStatus = "possible";
            } else if (calStatusArray.includes("wait")) {
                resStatus = "waiting";
            } else if (calStatusArray.includes("end")) {
                resStatus = "deadline";
            }
            result = {
                day: day,
                resStatus: resStatus,
                price: price,
                holiday: holiday
            };
            return result;
        });
        return (0,_to_consumable_array/* default */.Z)(firstWeekEmptyArray).concat((0,_to_consumable_array/* default */.Z)(dayArray), (0,_to_consumable_array/* default */.Z)(lastWeekEmptyArray));
    }, [
        groupByEvStartDt
    ]);
    /** event day 주 단위로 삽입 */ var eventDayList = (0,react.useMemo)(function() {
        var days = makeEventDayList(month.date(1));
        return Array.from({
            length: days.length / 7
        }).map(function() {
            return days.splice(0, 7);
        });
    }, [
        makeEventDayList
    ]);
    /** 첫 랜더링 디폴트 세팅 */ (0,react.useEffect)(function() {
        if (month) dateChange(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ScheduleTitle */.Hr, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "출발일 선택"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ReservationBox */.me, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ReservationText */._9, {
                                state: "possible",
                                children: "예약가능"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ReservationText */._9, {
                                state: "waiting",
                                children: "예약대기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ReservationText */._9, {
                                state: "deadline",
                                children: "예약마감"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBox, {
                id: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarMonthWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarMonth, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectWrap */.vA, {
                                    width: 83,
                                    id: "selectWrap-".concat(id),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarSelectBox, {
                                            types: "calendar",
                                            onClick: function() {
                                                return setShowMonth(!showMonth);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                isActive: true,
                                                children: month.format("YYYY.MM")
                                            })
                                        }),
                                        showMonth && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                            id: "options-".concat(id),
                                            children: rangeMonth === null || rangeMonth === void 0 ? void 0 : rangeMonth.map(function(day, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    value: day.format("YYYYMMDD"),
                                                    onClick: function(e) {
                                                        monthChange(String(e.currentTarget.value));
                                                        dateChange(null); // 선택일 초기화
                                                    },
                                                    children: day.format("YYYY.MM")
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                isPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                                    types: "prev",
                                    onClick: function() {
                                        prevMonth();
                                        dateChange(null);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "이전달"
                                    })
                                }),
                                isNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                                    types: "next",
                                    onClick: function() {
                                        nextMonth();
                                        dateChange(null);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "다음달"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCalendar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "일"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "월"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "화"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "수"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "목"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "금"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "토"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: eventDayList === null || eventDayList === void 0 ? void 0 : eventDayList.map(function(week, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                        children: week.map(function(item, weekIdx) {
                                            var day = item === null || item === void 0 ? void 0 : item.day;
                                            var price = (item === null || item === void 0 ? void 0 : item.price) || 0;
                                            var isActive = !(day < today.add(-1, "day")) && price > 0 || !!(item === null || item === void 0 ? void 0 : item.resStatus);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDays, {
                                                isActive: isActive,
                                                onClick: function() {
                                                    if (isActive) {
                                                        var isSameDay = date === null || date === void 0 ? void 0 : date.isSame(day);
                                                        dateChange(!isSameDay ? day : null);
                                                    }
                                                },
                                                CheckedDay: date && date.isSame(day),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Day, {
                                                        today: day && today.isSame(day, "day"),
                                                        holiday: item === null || item === void 0 ? void 0 : item.holiday,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: day && day.format("DD")
                                                        })
                                                    }),
                                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResStatus, {
                                                        state: (item === null || item === void 0 ? void 0 : item.resStatus) || "",
                                                        lowestPrice: price === Number(minPrice),
                                                        children: formatPrice(price)
                                                    })
                                                ]
                                            }, weekIdx);
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var EventListPopup_EventListCalendar = (EventListCalendar);

// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var alert_Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./framework/ui/desktop/filter/index.tsx
var filter = __webpack_require__(59758);
// EXTERNAL MODULE: ./framework/ui/desktop/input/index.ts + 8 modules
var input = __webpack_require__(51909);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListFIlters.tsx













var EventListFilters = function(prop) {
    var filters = prop.filters, setFilters = prop.setFilters, option = prop.option, goods = prop.goods;
    var goodsCd = goods.goodsCd, webDisplayCls = goods.webDisplayCls;
    var goodsState = [
        {
            key: "isEvReserve",
            text: "예약가능",
            value: "true"
        },
        {
            key: "isEvConfirm",
            text: "출발확정",
            value: "true"
        }, 
    ];
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref[0];
    var handleFilters = function(e, key) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var text = e.target.parentNode.innerText;
        if (checked) {
            var copyArray = filters;
            var copyArrayExists = copyArray.some(function(item) {
                return item.value === value && item.key === key;
            }); /* 중복제거 */ 
            if (copyArrayExists) return;
            setFilters((0,_to_consumable_array/* default */.Z)(filters).concat([
                {
                    key: key,
                    value: value,
                    text: text
                }
            ]));
        } else {
            if (key === "trCompanySnm" && filters.filter(function(v) {
                return v.key === "trCompanySnm";
            }).length === 1) {
                open(function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        text: "교통편은 최소 1개 이상 선택하셔야 합니다."
                    }));
                });
                return false;
            }
            if (key === "accomSeq" && filters.filter(function(v) {
                return v.key === "accomSeq";
            }).length === 1) {
                open(function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        text: "옵션은 최소 1개 이상 선택하셔야 합니다."
                    }));
                });
                return false;
            }
            var copyArray1 = filters;
            var setArray = copyArray1.filter(function(item) {
                return !(item.value === value && item.key === key);
            }); /* 동일한 value 제거 */ 
            setFilters(setArray);
        }
    };
    var handleFilterRemove = function(key, value) {
        var copyArray = filters;
        var setArray = copyArray.filter(function(item) {
            if (key === "price") {
                return !(item.key === "minPrice" || item.key === "maxPrice");
            } else {
                return !(item.value === value && item.key === key);
            }
        }); /* 동일한 value 제거 */ 
        setFilters(setArray);
    };
    var handleRemoveAll = function() {
        var setArray = filters.filter(function(v) {
            return constant/* D_DELETE_EXCLUDE_KEYS.includes */.CR.includes(v.key);
        });
        setFilters(setArray);
    };
    // 옵션 더보기 버튼
    var infoWrapRef = (0,react.useRef)(null);
    var infoContentRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), showText = ref1[0], setShowText = ref1[1];
    var ref2 = (0,react.useState)(false), shouldShowButton = ref2[0], setShouldShowButton = ref2[1];
    var toggleText = function() {
        setShowText(!showText);
        setShouldShowButton(false);
    };
    (0,react.useEffect)(function() {
        var ref, ref1;
        var textHeight = (ref = infoContentRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        var textWrapHeight = (ref1 = infoWrapRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight;
        if (textHeight > textWrapHeight) {
            setShouldShowButton(true);
        } else {
            setShouldShowButton(false);
        }
    }, [
        option
    ]);
    // 선택된 필터
    var showFilter = (0,react.useMemo)(function() {
        var arr = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (key === "minPrice") {
                    var minPrice = filters.find(function(v) {
                        return v.key === "minPrice";
                    });
                    if (minPrice) arr = (0,_to_consumable_array/* default */.Z)(arr).concat([
                        {
                            key: "price",
                            text: minPrice.text
                        }
                    ]);
                } else if (key === "maxPrice") {
                    var maxPrice = filters.find(function(v) {
                        return v.key === "maxPrice";
                    });
                    var priceObject = arr.find(function(v) {
                        return v.key === "price";
                    });
                    if (priceObject && maxPrice) priceObject.text += " ~ ".concat(maxPrice.text);
                } else {
                    arr = (0,_to_consumable_array/* default */.Z)(arr).concat((0,_to_consumable_array/* default */.Z)(filters.filter(function(v) {
                        return v.key === key;
                    })));
                }
            };
            for(var _iterator = constant/* D_SHOW_KEYS */.D9[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return arr;
    }, [
        filters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showFilter.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* FilterTagContainer */.m2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FilterTitle */.Ux, {
                        children: "필터"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* FilterTagBox */.lD, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ResetButton */.JK, {
                                    type: "button",
                                    onClick: handleRemoveAll,
                                    children: "전체 삭제"
                                })
                            }),
                            showFilter.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* FilterTag */.dB, {
                                        children: [
                                            item.text,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FilterTagDeleteButton */.i4, {
                                                onClick: function() {
                                                    return handleFilterRemove(item.key, item.value);
                                                },
                                                children: "닫기"
                                            })
                                        ]
                                    })
                                }, "".concat(goodsCd).concat(index));
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FilterCheckWrap */.FB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                    lineTop: true,
                    types: "basic",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                            children: "상품가 안내"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "120px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "auto"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "상품 상태"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CheckBox */.Jg, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* GridList */.e_, {
                                                    columns: "repeat(4, 1fr)",
                                                    children: goodsState.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                                                    id: "state".concat(goodsCd).concat(index),
                                                                    value: "".concat(item.value),
                                                                    checked: filters.some(function(v) {
                                                                        return v.key === item.key;
                                                                    }) || false,
                                                                    onChange: function(e) {
                                                                        return handleFilters(e, item.key);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "state".concat(goodsCd).concat(index),
                                                                    children: item.text
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                (option === null || option === void 0 ? void 0 : option.trafficList) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "교통편"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CheckBox */.Jg, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* GridList */.e_, {
                                                    columns: "repeat(4, 1fr)",
                                                    children: option.trafficList.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                                                    id: "airline".concat(goodsCd).concat(index),
                                                                    value: "".concat(item.trCompanySnm),
                                                                    checked: filters.some(function(v) {
                                                                        return v.value === item.trCompanySnm;
                                                                    }) || false,
                                                                    onChange: function(e) {
                                                                        return handleFilters(e, "trCompanySnm");
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "airline".concat(goodsCd).concat(index),
                                                                    children: item.trCompanySnm === "ETC" ? "교통불포함" : item.trCompanyNm
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                webDisplayCls === "B" && (option === null || option === void 0 ? void 0 : option.accommodationList) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "옵션"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* CheckBox */.Jg, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* OptionCheckList */.qe, {
                                                        show: showText,
                                                        ref: infoWrapRef,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* GridList */.e_, {
                                                            columns: "1fr",
                                                            ref: infoContentRef,
                                                            children: option.accommodationList.map(function(item, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                                                            id: "option".concat(goodsCd).concat(index),
                                                                            value: "".concat(item.accomSeq),
                                                                            checked: filters.some(function(v) {
                                                                                return v.value === String(item.accomSeq);
                                                                            }) || false,
                                                                            onChange: function(e) {
                                                                                return handleFilters(e, "accomSeq");
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            htmlFor: "option".concat(goodsCd).concat(index),
                                                                            children: item.accomNm
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        })
                                                    }),
                                                    shouldShowButton && option.accommodationList.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* BenefitButton */.Xk, {
                                                        type: "button",
                                                        onClick: toggleText,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "더보기"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var EventListFIlters = (EventListFilters);

// EXTERNAL MODULE: ./components/product/pages/localList/common/filterHook.tsx
var filterHook = __webpack_require__(87061);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 8 modules
var desktop_button = __webpack_require__(36432);
// EXTERNAL MODULE: ./framework/ui/desktop/flag/index.ts
var flag = __webpack_require__(34869);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 4 modules
var popup = __webpack_require__(16628);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsLive.ts
var useGlobalGoodsLive = __webpack_require__(28906);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerGoodsDeal.ts
var useBannerGoodsDeal = __webpack_require__(82767);
// EXTERNAL MODULE: ./hooks/services/queries/portal/useGoodsBannerPick.ts
var useGoodsBannerPick = __webpack_require__(38307);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventByMonth.ts
var useEventByMonth = __webpack_require__(67964);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsDetail.ts
var useGoodsDetail = __webpack_require__(3081);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOption.ts
var useGoodsOption = __webpack_require__(29306);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListPopup.tsx



































var EventInfo = function(goods) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var dspSid = "".concat((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.dspSid) === null || ref1 === void 0 ? void 0 : ref1.slice(0, -2), "00");
    var menu = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.menu;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GOST"); // WEB_CONT_DIVI_CD 출발일보기
    var bannerContents = (ref3 = bannerContentsFetch.data) === null || ref3 === void 0 ? void 0 : ref3.body;
    var bannerDealFetch = (0,useBannerGoodsDeal/* default */.ZP)(goods.goodsCd);
    var bannerDeal = (ref4 = bannerDealFetch.data) === null || ref4 === void 0 ? void 0 : ref4.body;
    var bannerLiveFetch = (0,useGlobalGoodsLive/* default */.Z)(goods.goodsCd);
    var bannerLive = (ref5 = bannerLiveFetch.data) === null || ref5 === void 0 ? void 0 : ref5.body;
    var bannerPickFetch = (0,useGoodsBannerPick/* default */.ZP)(goods.goodsCd);
    var bannerPick = (ref6 = bannerPickFetch.data) === null || ref6 === void 0 ? void 0 : ref6.body;
    // 공유하기
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref7[0];
    var handleShare = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                baseUrl: "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL, "/product/localList"),
                parameter: "menu=".concat(menu, "&dspSid=").concat(dspSid, "&goodsCd=").concat(goods.goodsCd)
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ContentTop */.an, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* SummaryInfo */.T7, {
                justify: "space-between",
                align: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* TagSquareWrap */.N$, {
                        gap: "5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsCd */.G, {
                                goodsCd: goods.goodsCd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsTp */.B2, {
                                goodsTp: goods.goodsTp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsBrandCd */.hA, {
                                goodsBrandCd: goods.goodsBrandCd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsTmember */.$4, {
                                goodsTmember: goods.goodsTmember
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* StackList */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flag/* StarIcon */.r7, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Grade */.GR, {
                                            children: goods.rvwAvgScore > 0 ? goods.rvwAvgScore : "-"
                                        }),
                                        "/ 5"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
                                    icon: "share",
                                    isActive: false,
                                    onClick: handleShare,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "공유하기"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* TopTitle */.ne, {
                children: goods.goodsNm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* TopPriceBox */.Yo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        gap: "2",
                        align: "center",
                        children: [
                            "최저가",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* RedText */.xK, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(goods.minPrice)
                                    }),
                                    " 원"
                                ]
                            }),
                            "(",
                            dayjs_min_default()(goods.minPriceDate).format("YYYY.MM.DD"),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        gap: "2",
                        align: "center",
                        children: [
                            "최고가",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* RedText */.xK, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(goods.maxPrice)
                                    }),
                                    " 원"
                                ]
                            }),
                            "(",
                            dayjs_min_default()(goods.maxPriceDate).format("YYYY.MM.DD"),
                            ")"
                        ]
                    })
                ]
            }),
            bannerContents && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContents, {
                contents: bannerContents
            }),
            bannerPick && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPick, {
                pick: bannerPick
            }),
            bannerDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPangDeal, {
                deal: bannerDeal
            }),
            bannerLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowLive, {
                live: bannerLive
            })
        ]
    });
};
var EventSort = function(props) {
    var sort = props.sort, handleSort = props.handleSort;
    var Rating = [
        {
            text: "출발일순",
            prop: "outStartDt",
            asc: true
        },
        {
            text: "낮은가격순",
            prop: "sumPrice",
            asc: true
        },
        {
            text: "높은가격순",
            prop: "sumPrice",
            asc: false
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ScheduleTitle */.Hr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: "일정 선택"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackList */.fe, {
                cursor: "pointer",
                children: Rating.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                        "data-prop": item.prop,
                        "data-asc": item.asc,
                        "data-text": item.text,
                        isActive: (sort === null || sort === void 0 ? void 0 : sort.text) === item.text,
                        onClick: handleSort,
                        children: item.text
                    }, index);
                })
            })
        ]
    });
};
var EventContentsComponent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var getFilter = (0,filterHook/* default */.Z)().getFilter;
    var ref6 = (0,react.useState)([]), filters = ref6[0], setFilters = ref6[1];
    var router = (0,next_router.useRouter)();
    var goods = props.goods, availEvent = props.availEvent, onClose = props.onClose;
    var goodsCd = goods.goodsCd, webDisplayCls = goods.webDisplayCls, minPrice = goods.minPrice;
    var dspSid = "".concat((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.dspSid) === null || ref1 === void 0 ? void 0 : ref1.slice(0, -2), "00");
    var optionFetch = (0,useGoodsOption/* default */.ZP)(goodsCd, {
        staleTime: 1000 * 60
    });
    var option = (ref2 = optionFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var calendarRef = (0,react.useRef)(null);
    /** 행사리스트 필터링에 사용 (YYYYMMDD) */ var ref7 = (0,react.useState)(null), currentDate = ref7[0], setCurrentDate = ref7[1];
    /** 달력 세팅에 사용 (YYYYMM) */ var ref8 = (0,react.useState)(null), currentMonth = ref8[0], setCurrentMonth = ref8[1];
    /** 최소 날짜, 최대 날짜, 이벤트 날짜 세팅 */ var ref9 = (0,react.useMemo)(function() {
        if (!availEvent) return [
            null,
            null
        ];
        var _eventMonthList = availEvent.eventMonthList, minOutStartDt = _eventMonthList.minOutStartDt, maxOutStartDt = _eventMonthList.maxOutStartDt;
        setCurrentMonth(dayjs_min_default()(availEvent.evStartDt).date(1).format("YYYYMM"));
        return [
            minOutStartDt,
            maxOutStartDt
        ];
    }, [
        availEvent
    ]), minDate = ref9[0], maxDate = ref9[1];
    /** 필터링 된 날짜 세팅 */ (0,react.useEffect)(function() {
        if (!filters.length) return;
        var dateFilter = filters.find(function(v) {
            return v.key === "outStartDt";
        });
        var monthFilter = filters.find(function(v) {
            return v.key === "outStartMonth";
        });
        var newDate = dateFilter ? dateFilter.value : null;
        var newMonth = monthFilter ? monthFilter.value : null;
        newMonth && setCurrentMonth(newMonth);
        newDate && setCurrentMonth(dayjs_min_default()(newDate).format("YYYYMM"));
        newDate && setCurrentDate(newDate);
    }, [
        filters
    ]);
    /** 달력 동기화 */ (0,react.useEffect)(function() {
        var ref;
        (ref = calendarRef.current) === null || ref === void 0 ? void 0 : ref.monthChange(currentMonth);
    }, [
        currentMonth
    ]);
    /** 달 변경 콜백 */ var onMonthChange = function(day) {
        var newMonth = day ? day.format("YYYYMM") : null;
        setCurrentMonth(newMonth);
    };
    /** 날짜 변경 콜백 */ var onDateChange = function(day) {
        var newDate = day ? day.format("YYYYMMDD") : null;
        setCurrentDate(newDate);
    };
    var eventByGoodsMonthFetch = (0,useEventByMonth/* default */.Z)(dspSid, goodsCd, currentMonth, {
        enabled: !!currentMonth && !optionFetch.isLoading,
        staleTime: 1000 * 60,
        select: function select(data) {
            var eventData = data.body;
            eventData === null || eventData === void 0 ? void 0 : eventData.map(function(event) {
                var evProgDivi = event.evProgDivi, avlilBlockQty = event.avlilBlockQty, adtPrice = event.adtPrice, airTaxAdtPrice = event.airTaxAdtPrice, bafAdtPrice = event.bafAdtPrice;
                event.sumPrice = adtPrice + airTaxAdtPrice + bafAdtPrice;
                event.isEvReserve = "false"; // 예약가능 여부
                event.isEvConfirm = "false"; // 출발확정 여부
                if (evProgDivi !== "05" && (evProgDivi !== "00" && avlilBlockQty > 0 || evProgDivi === "00" || avlilBlockQty <= 0)) {
                    event.isEvReserve = "true";
                }
                if (evProgDivi === "07" || evProgDivi === "11") {
                    event.isEvConfirm = "true";
                }
                if (evProgDivi === "05") {
                    event.evReserveStatus = "end";
                } else if (evProgDivi === "00" || avlilBlockQty <= 0) {
                    event.evReserveStatus = "wait";
                } else {
                    event.evReserveStatus = "can";
                }
                return event.sumPrice;
            });
            return {
                minPrice: minPrice,
                list: eventData
            };
        }
    });
    var orgEventList = eventByGoodsMonthFetch.data;
    // 정렬 sort
    var ref10 = (0,react.useState)({
        text: "출발일순",
        prop: "outStartDt",
        asc: true
    }), sort = ref10[0], setSort = ref10[1];
    var handleSort = function(e) {
        var _dataset = e.target.dataset, text = _dataset.text, prop = _dataset.prop, asc = _dataset.asc;
        setSort({
            text: text,
            prop: prop,
            asc: asc === "true"
        });
    };
    // 필터 초기화
    (0,react.useEffect)(function() {
        var ref;
        if (!option) return;
        var currentFilter = ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "sort";
        })) || [];
        var result = (0,_to_consumable_array/* default */.Z)(currentFilter.filter(function(v) {
            return v.key !== "airCd";
        }));
        // 날짜 데이터 세팅
        var outStartDateList = currentFilter.find(function(v) {
            return v.key === "outStartDateList";
        });
        if (outStartDateList) {
            if (outStartDateList.value.length === 6) {
                result.push({
                    key: "outStartMonth",
                    text: outStartDateList.text,
                    value: outStartDateList.value
                });
            } else if (outStartDateList.value.length === 8) {
                result.push({
                    key: "outStartDt",
                    text: outStartDateList.text,
                    value: outStartDateList.value
                });
            }
            result = result.filter(function(v) {
                return v.key !== "outStartDateList";
            });
        }
        var accommodationList = option.accommodationList, trafficList = option.trafficList;
        // 옵션
        if ((accommodationList === null || accommodationList === void 0 ? void 0 : accommodationList.length) > 0 && webDisplayCls === "B") {
            var _result;
            var accom = accommodationList.map(function(item) {
                return {
                    key: "accomSeq",
                    value: String(item.accomSeq),
                    text: item.accomNm
                };
            });
            (_result = result).push.apply(_result, (0,_to_consumable_array/* default */.Z)(accom));
        }
        // 교통편
        if (currentFilter.find(function(v) {
            return v.key === "airCd";
        })) {
            var _result1;
            var ref1;
            // 리스트에 선택된것만 세팅
            var airCdArray = (ref1 = currentFilter.filter(function(v) {
                return v.key === "airCd";
            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(i) {
                return i.value;
            });
            var traffic = trafficList.filter(function(item) {
                return airCdArray.includes(item.trCompanySnm);
            }).map(function(item) {
                return {
                    key: "trCompanySnm",
                    value: item.trCompanySnm,
                    text: item.trCompanyNm
                };
            });
            (_result1 = result).push.apply(_result1, (0,_to_consumable_array/* default */.Z)(traffic));
        } else {
            var _result2;
            var traffic1 = trafficList.map(function(item) {
                return {
                    key: "trCompanySnm",
                    value: item.trCompanySnm,
                    text: item.trCompanyNm
                };
            });
            (_result2 = result).push.apply(_result2, (0,_to_consumable_array/* default */.Z)(traffic1));
        }
        setFilters(result);
    }, [
        option
    ]);
    /** 필터 된 리스트 */ var filteredList = (0,react.useMemo)(function() {
        if (!orgEventList) return;
        var minPrice = orgEventList.minPrice, list = orgEventList.list;
        var copyArray = list;
        filters === null || filters === void 0 ? void 0 : filters.forEach(function(item) {
            var filterKey = item.key;
            if (constant/* D_EXCLUDE_KEYS.indexOf */.we.indexOf(filterKey) > -1) return;
            copyArray = copyArray === null || copyArray === void 0 ? void 0 : copyArray.reduce(function(acc, event) {
                var filterKeyList = filters.filter(function(v) {
                    return v.key === filterKey;
                });
                filterKeyList.some(function(filter) {
                    var key = filter.key, value = filter.value;
                    if (key === "minPrice") return Number(event.sumPrice) >= Number(value);
                    if (key === "maxPrice") return Number(event.sumPrice) <= Number(value);
                    return event[key] && event[key].indexOf(value) > -1;
                // eslint-disable-next-line no-param-reassign
                }) && (acc = acc.concat(event));
                return acc;
            }, []);
        });
        return {
            minPrice: minPrice,
            eventList: copyArray || []
        };
    }, [
        filters,
        orgEventList,
        currentMonth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ContentBottom */.pH, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* Schedule */.Pf, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FixedScheduleWrap */.PT, {
                    children: currentMonth && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventListCalendar, {
                        value: currentMonth,
                        data: filteredList,
                        maxDate: maxDate,
                        minDate: minDate,
                        onDateChange: onDateChange,
                        onMonthChange: onMonthChange,
                        ref: calendarRef
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ScheduleWrap */.HA, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventSort, {
                            sort: sort,
                            handleSort: function(e) {
                                return handleSort(e);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ScrollHeightBox */.fY, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListFIlters, {
                                        filters: filters,
                                        setFilters: setFilters,
                                        option: option,
                                        goods: goods
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionWrap */.Kf, {
                                        children: [
                                            filteredList && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventList, {
                                                data: filteredList.eventList,
                                                currentDate: currentDate,
                                                sort: sort,
                                                filters: filters,
                                                setFilters: setFilters,
                                                onClose: onClose
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* CalendarControl */.hS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CalendarButton */.au, {
                                                        type: "button",
                                                        month: "prev",
                                                        onClick: function() {
                                                            return calendarRef.current.prevMonth();
                                                        },
                                                        disabled: !((ref3 = calendarRef.current) === null || ref3 === void 0 ? void 0 : ref3.isPrevious),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "이전달"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: dayjs_min_default()((ref4 = calendarRef.current) === null || ref4 === void 0 ? void 0 : ref4.month).format("YYYY.MM")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CalendarButton */.au, {
                                                        type: "button",
                                                        month: "next",
                                                        onClick: function() {
                                                            return calendarRef.current.nextMonth();
                                                        },
                                                        disabled: !((ref5 = calendarRef.current) === null || ref5 === void 0 ? void 0 : ref5.isNext),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "다음달"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var EventContents = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventListPop EventContents Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContentsComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var EventListPopComponent = function(props) {
    var ref;
    var goodsCd = props.goodsCd, availEvent = props.availEvent, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "goodsCd",
        "availEvent"
    ]);
    var goodsFetch = (0,useGoodsDetail/* default */.ZP)(goodsCd);
    var goods = (ref = goodsFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    if (goodsFetch.isFetching) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
            size: "full",
            title: "출발일 보기",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ContentWrap */.Xs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInfo, (0,_object_spread/* default */.Z)({}, goods)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContents, {
                        goods: goods,
                        availEvent: availEvent,
                        onClose: overlayProps.close
                    })
                ]
            })
        }))
    });
};
// 출발일 보기
var EventListPopup = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventListPop Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var EventListPopup_EventListPopup = (EventListPopup);


/***/ }),

/***/ 59758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hu": function() { return /* binding */ SearchWrap; },
/* harmony export */   "IZ": function() { return /* binding */ OptionWrap; },
/* harmony export */   "Lf": function() { return /* binding */ OptionTextField; },
/* harmony export */   "YH": function() { return /* binding */ FilterHeader; },
/* harmony export */   "e_": function() { return /* binding */ GridList; },
/* harmony export */   "iu": function() { return /* binding */ OptionTitle; },
/* harmony export */   "mE": function() { return /* binding */ RatingHeader; },
/* harmony export */   "ol": function() { return /* binding */ Search; },
/* harmony export */   "tX": function() { return /* binding */ FloatingWrap; },
/* harmony export */   "wf": function() { return /* binding */ FloatingContent; }
/* harmony export */ });
/* unused harmony exports FilterTag, FilterTagWrap, OptionItem, OptionList, IconBox */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93391);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14358);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _FRAMEWORK_ui_desktop_icon_SearchIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75412);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 100%;\n	min-height: 60px;\n	padding: 10px 0;\n	border-bottom: 1px solid var(--line-color);\n	background-color: #fff;\n	box-sizing: border-box;\n	align-items: center;\n	justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: flex;\n	margin-right: 10px;\n	background-color: transparent;\n	color: var(--default-color);\n	align-items: center;\n	line-height: 1;\n\n	i {\n		display: block;\n		position: relative;\n		width: 12px;\n		height: 12px;\n		margin-left: 5px;\n		font-size: 0;\n\n		&::before,\n		&::after {\n			position: absolute;\n			top: 50%;\n			left: 0;\n			right: 0;\n			height: 1px;\n			background: #7c7c7c;\n			transform: translateY(-50%);\n			content: "";\n		}\n\n		&::before {\n			transform: rotate(45deg);\n		}\n\n		&::after {\n			transform: rotate(-45deg);\n		}\n	}\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: flex;\n	padding-left: 10px;\n	margin-left: 10px;\n	align-items: center;\n	flex-wrap: wrap;\n	gap: 5px;\n\n	&::before {\n		position: absolute;\n		left: 0;\n		top: 50%;\n		display: block;\n		width: 1px;\n		height: 13px;\n		background-color: var(--line-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	li {\n		display: flex;\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	width: 240px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	height: 100%;\n	border-bottom: 1px solid var(--line-color);\n	cursor: pointer;\n\n	&:last-child {\n		border-bottom: none;\n	}\n\n	input[type="checkbox"] {\n		position: absolute;\n		width: 1px;\n		height: 1px;\n		padding: 0;\n		margin: -1px;\n		overflow: hidden;\n		clip: rect(0, 0, 0, 0);\n		border: 0;\n	}\n\n	label {\n		display: block;\n		height: 38px;\n		color: var(--default-color);\n		line-height: 38px;\n		text-overflow: ellipsis;\n		white-space: nowrap;\n		overflow: hidden;\n	}\n\n	input[type="checkbox"]:checked + label {\n		color: var(--emp-color);\n		background-color: var(--yellow-color);\n	}\n\n	span {\n		display: flex;\n		height: 100%;\n		align-items: center;\n		justify-content: center;\n		color: var(--bl-color);\n		cursor: auto;\n	}\n\n	',
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	max-height: ",
        ";\n	margin-bottom: 20px;\n	border: 1px solid var(--line-color);\n	flex-direction: ",
        ";\n	overflow-y: auto;\n\n	label {\n		padding-left: 10px;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	margin: 0 1px;\n	grid-template-columns: ",
        ";\n	grid-gap: 1px;\n\n	li {\n		border: none;\n		outline: 1px solid var(--line-color);\n		text-align: center;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	margin-bottom: 20px;\n	gap: 5px;\n	align-items: center;\n\n	input {\n		width: 100%;\n		text-align: right;\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	padding: 20px 0;\n	border-top: 1px solid var(--line-color);\n	font-size: var(--default-size);\n	color: var(--emp-color);\n	line-height: 1;\n	cursor: pointer;\n\n	&::before {\n		position: absolute;\n		right: 0;\n		top: 50%;\n		width: 10px;\n		height: 2px;\n		background-color: var(--emp-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	&::after {\n		position: absolute;\n		right: 4px;\n		top: 50%;\n		width: 2px;\n		height: 10px;\n		background-color: var(--emp-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	',
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 0;\n	display: none;\n\n	",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 100%;\n	height: 80px;\n	background-color: #fff;\n	align-items: center;\n	justify-content: space-between;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	background-color: #fff;\n	border: 1px solid var(--line-color);\n	align-items: center;\n\n	input {\n		width: 204px;\n		height: 38px;\n		padding: 0 0 0 9px;\n		border: none;\n\n		&::palceholder {\n			color: var(--gray-color);\n		}\n	}\n\n	button {\n		width: 16px;\n		height: 15px;\n		margin: 0 9px;\n		background: url(",
        ") 0px 0px / 93px 40px;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 20px 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	height: 40px;\n	padding: 0 10px;\n	align-items: center;\n	border: 1px solid var(--line-color);\n	box-sizing: border-box;\n	background-color: #fff;\n\n	span {\n		margin-left: 8px;\n		font-family: "PT-medium";\n		color: var(--blue-color);\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var FilterHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-0"
})(_templateObject());
var FilterTag = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].button.withConfig({
    componentId: "sc-c67f309-1"
})(_templateObject1());
var FilterTagWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({
    componentId: "sc-c67f309-2"
})(_templateObject2());
var FloatingContent = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-3"
})(_templateObject3());
var FloatingWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-4"
})(_templateObject4());
var OptionItem = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].li.withConfig({
    componentId: "sc-c67f309-5"
})(_templateObject5(), function(props) {
    return props.width && "\n        border-bottom: none;\n        border-right: 1px solid var(--line-color);\n        flex: 1 1 ".concat(props.width, ";\n        justify-content: center;\n\n        &:last-child {\n            border-right: none;\n        }\n\n        > label {\n            padding-left: 0;\n            justify-content: center;\n            text-align: center;\n        }\n    ");
});
var OptionList = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({
    componentId: "sc-c67f309-6"
})(_templateObject6(), function(props) {
    return props.height || "195px";
}, function(props) {
    return props.direction || "column";
});
var GridList = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({
    componentId: "sc-c67f309-7"
})(_templateObject7(), function(props) {
    return props.columns;
});
var OptionTextField = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-8"
})(_templateObject8());
var OptionTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].h3.withConfig({
    componentId: "sc-c67f309-9"
})(_templateObject9(), function(props) {
    return props.active && "\n        &::after {\n            display: none;\n        }\n    ";
});
var OptionWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-10"
})(_templateObject10(), function(props) {
    return props.show && "\n        height: auto;\n        display: block;\n    ";
});
var RatingHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-11"
})(_templateObject11());
var Search = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-12"
})(_templateObject12(), (_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default()));
var SearchWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-13"
})(_templateObject13());
var IconBoxWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-c67f309-14"
})(_templateObject14());
var IconBox = function(_param) {
    var props = _extends({}, _param);
    /*#__PURE__*/ return _jsxs(IconBoxWrap, {
        onClick: props === null || props === void 0 ? void 0 : props.onClick,
        children: [
            /*#__PURE__*/ _jsx(SearchIcon, _object_spread({}, props)),
            /*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: props.innerHtml
                }
            })
        ]
    });
};



/***/ }),

/***/ 4866:
/***/ (function(module) {

module.exports = "/_next/static/images/banner_yellowpick_1200.GJOUQvPK.png";

/***/ }),

/***/ 15196:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ })

}]);